import React, { useState, useEffect } from "react";
import { API_URL } from '../config';
import BitrixAPI from "../api/b24";
import FilePreview from "../components/FileViewer";
import LoadingButton from "../components/LoadingButton";
import DriverDeliveryInfo from "../components/DriverDeliveryInfo";
import axios from 'axios';
import { useHeader } from "../contexts/HeaderContext";


const API_BASE_URL = API_URL;

const ZakalkaOrdersPageB24 = () => {
  const [activeOrders, setActiveOrders] = useState([]);
  const [nazakOrders, setNazakOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingOrders, setProcessingOrders] = useState(new Set());
  const [activeTab, setActiveTab] = useState("shipping");
  const [error, setError] = useState(null);
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [generatingPartnerPDF, setGeneratingPartnerPDF] = useState(false);
  const [printingPDF, setPrintingPDF] = useState(false);
  const [printingPartnerPDF, setPrintingPartnerPDF] = useState(false);
  const [savingAll, setSavingAll] = useState(false);
  const [selectedOrdersForTrip, setSelectedOrdersForTrip] = useState(new Set());
  const [creatingTrip, setCreatingTrip] = useState(false);
  // Убраны переменные связанные с проверкой batches
  const [loadingDetails, setLoadingDetails] = useState(new Set()); // ID заказов, для которых сейчас загружаются детали

  // Состояния для деталировки всех заказов
  const [ordersDetails, setOrdersDetails] = useState({}); // {orderId: {glassDetails: [], selectedDetails: Set(), quantities: Map()}}
  const [ordersComments, setOrdersComments] = useState({}); // {orderId: "comments"}
  const [showFilesForOrder, setShowFilesForOrder] = useState(null);
  
  // Состояние для поиска
  const [searchQuery, setSearchQuery] = useState("");

  const { setHeaderExtras } = useHeader();

  // Состояние для polling новых заказов
  const [isPollingActive, setIsPollingActive] = useState(true);
  const [newOrdersNotification, setNewOrdersNotification] = useState(null); // {count: number, orderNumbers: string[]}

  // Состояние для фильтра просмотра
  const [viewFilter, setViewFilter] = useState("orders"); // "orders" или "details"

  // Состояние для свайп-кнопок
  const [swipeStates, setSwipeStates] = useState({});

  // Состояния для управления рейсами
  const [trips, setTrips] = useState([]); // Список всех рейсов
  const [selectedTrip, setSelectedTrip] = useState(null); // Выбранный рейс для детального просмотра
  const [showTripModal, setShowTripModal] = useState(false); // Показывать модальное окно просмотра
  const [showEditModal, setShowEditModal] = useState(false); // Модальное окно редактирования деталей
  const [showViewTripModal, setShowViewTripModal] = useState(false); // Модальное окно просмотра рейса
  const [viewingTrip, setViewingTrip] = useState(null); // Рейс для просмотра
  const [receivedDetails, setReceivedDetails] = useState({}); // Детали которые приехали при приемке {detailId: quantity}
  const [editingTrip, setEditingTrip] = useState(null); // Рейс который редактируется (null = создание нового)
  const [tripFilter, setTripFilter] = useState("all"); // Фильтр: all, draft, shipped, received
  const [loadingTrips, setLoadingTrips] = useState(false); // Загрузка списка рейсов
  const [tripPartner, setTripPartner] = useState('Казстековид'); // Партнер закалки
  const [tripDetails, setTripDetails] = useState([]); // Детали рейса в модальном окне
  const [tripDetailsSearch, setTripDetailsSearch] = useState(''); // Поиск деталей в модальном окне
  const [tripDetailsThicknessFilter, setTripDetailsThicknessFilter] = useState('all'); // Фильтр по толщине: 'all' или конкретная толщина
  const [tripDetailsData, setTripDetailsData] = useState({}); // {tripId: [...details]}
  const [loadingTripDetails, setLoadingTripDetails] = useState(new Set()); // ID рейсов для которых загружаются детали
  const [receivingDetailsSearch, setReceivingDetailsSearch] = useState(''); // Поиск в модальном окне приёмки
  const [receivingThicknessFilter, setReceivingThicknessFilter] = useState('all'); // Фильтр по толщине в приёмке
  const [detailsInTrips, setDetailsInTrips] = useState(new Set()); // Set ID деталей которые уже в активных рейсах

  // Состояния для модального окна редактирования
  const [availableDetails, setAvailableDetails] = useState([]); // Доступные детали для добавления
  const [availableDetailsSearch, setAvailableDetailsSearch] = useState(''); // Поиск доступных деталей
  const [loadingTripDetailsInModal, setLoadingTripDetailsInModal] = useState(false); // Загрузка деталей в модалке редактирования
  const [loadingAvailableDetailsInModal, setLoadingAvailableDetailsInModal] = useState(false); // Загрузка доступных деталей
  const [editModalTab, setEditModalTab] = useState('details'); // Вкладка в модальном окне: 'details', 'info', 'preview'

  // Состояния для отслеживания статуса сохранения деталей (для каждой детали отдельно)
  const [detailSavingStatus, setDetailSavingStatus] = useState({}); // {`${orderId}_${detailId}`: 'idle' | 'saving' | 'saved' | 'error'}

  // Таймеры для debounce автосохранения (для каждой детали отдельно)
  const saveTimersRef = React.useRef({}); // {`${orderId}_${detailId}`: timeoutId}

  // Компонент индикатора статуса сохранения (для конкретной детали)
  const SaveStatusIndicator = ({ orderId, detailId }) => {
    const detailKey = `detail_${detailId}`;
    const status = detailSavingStatus[detailKey] || 'idle';

    if (status === 'idle') {
      return null;
    }

    if (status === 'saving') {
      return (
        <span className="inline-flex items-center px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700">
          <svg className="animate-spin -ml-1 mr-1.5 h-3 w-3 text-blue-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Сохранение...
        </span>
      );
    }

    if (status === 'saved') {
      return (
        <span className="inline-flex items-center px-2 py-1 text-xs rounded-full bg-green-100 text-green-700">
          <svg className="mr-1.5 h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
          </svg>
          Сохранено
        </span>
      );
    }

    if (status === 'error') {
      return (
        <span className="inline-flex items-center px-2 py-1 text-xs rounded-full bg-red-100 text-red-700">
          <svg className="mr-1.5 h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
          </svg>
          Ошибка
        </span>
      );
    }

    return null;
  };

  // Компонент свайп-кнопки
  const SwipeToConfirmButton = ({ 
    orderId, 
    onConfirm, 
    isLoading, 
    buttonText = "Свайп для завершения →",
    completedText = "Отпустите для завершения", 
    processingText = "Обработка..."
  }) => {
    const [dragX, setDragX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [startX, setStartX] = useState(0);
    const maxDrag = 200; // Максимальное расстояние для свайпа
    const threshold = 150; // Пороговое значение для активации
    const sliderRef = React.useRef(null);
    
    const handleSliderMouseDown = (e) => {
      setIsDragging(true);
      setStartX(e.clientX);
      e.preventDefault();
      e.stopPropagation();
    };
    
    const handleSliderTouchStart = (e) => {
      setIsDragging(true);
      setStartX(e.touches[0].clientX);
      e.preventDefault();
      e.stopPropagation();
    };
    
    const handleGlobalMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      setDragX(Math.max(0, Math.min(deltaX, maxDrag)));
      e.preventDefault();
    };
    
    const handleGlobalTouchMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.touches[0].clientX - startX;
      setDragX(Math.max(0, Math.min(deltaX, maxDrag)));
      e.preventDefault();
    };
    
    const handleEnd = () => {
      if (dragX >= threshold && !isCompleted) {
        setIsCompleted(true);
        onConfirm(orderId);
      }
      setIsDragging(false);
      setDragX(0);
      setStartX(0);
    };
    
    // Добавляем глобальные обработчики только при перетаскивании
    React.useEffect(() => {
      if (isDragging) {
        document.addEventListener('mousemove', handleGlobalMouseMove, { passive: false });
        document.addEventListener('mouseup', handleEnd);
        document.addEventListener('touchmove', handleGlobalTouchMove, { passive: false });
        document.addEventListener('touchend', handleEnd);
        
        return () => {
          document.removeEventListener('mousemove', handleGlobalMouseMove);
          document.removeEventListener('mouseup', handleEnd);
          document.removeEventListener('touchmove', handleGlobalTouchMove);
          document.removeEventListener('touchend', handleEnd);
        };
      }
    }, [isDragging, startX, dragX, threshold, isCompleted]);
    
    const progress = (dragX / maxDrag) * 100;
    const isActivated = dragX >= threshold;
    
    return (
      <div className="relative w-full h-12 bg-gray-200 rounded-lg overflow-hidden select-none pointer-events-none">
        {/* Прогресс-бар */}
        <div 
          className={`absolute inset-y-0 left-0 transition-colors duration-200 pointer-events-none ${
            isActivated ? 'bg-green-400' : 'bg-blue-400'
          }`}
          style={{ width: `${progress}%` }}
        />
        
        {/* Слайдер - только здесь можно начать перетаскивание */}
        <div 
          ref={sliderRef}
          className={`absolute top-1 left-1 w-10 h-10 rounded-md shadow-md transition-colors duration-200 flex items-center justify-center cursor-grab pointer-events-auto ${
            isActivated ? 'bg-green-600' : 'bg-blue-600'
          } ${isDragging ? 'cursor-grabbing' : ''}`}
          style={{ 
            transform: `translateX(${dragX}px)`,
            transition: isDragging ? 'none' : 'transform 0.3s ease'
          }}
          onMouseDown={handleSliderMouseDown}
          onTouchStart={handleSliderTouchStart}
        >
          {isLoading ? (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <span className="text-white text-xs">→</span>
          )}
        </div>
        
        {/* Текст */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className={`text-sm font-medium transition-colors duration-200 ${
            isActivated ? 'text-white' : 'text-gray-600'
          }`}>
            {isLoading ? processingText : isActivated ? completedText : buttonText}
          </span>
        </div>
      </div>
    );
  };
  

  const handleStageUpdate = async (orderId) => {
    try {
      setProcessingOrders(prev => new Set([...prev, orderId]));
      setError(null);
      
      const result = await BitrixAPI.updateStagezakalka(orderId);
  
      if (result && result.success) {
        if (activeTab === "shipping") {
          setActiveOrders(prevOrders => 
            prevOrders.filter(order => order.id !== orderId)
          );
        }
        console.log(`Заказ ${orderId} успешно переведен из закалки`);
      } else {
        throw new Error(result?.message || 'Не удалось обновить стадию');
      }
  
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      setError(`Ошибка при обновлении заказа ${orderId}: ${error.message}`);
      alert(`Ошибка: ${error.message}`);
    } finally {
      setProcessingOrders(prev => {
        const newSet = new Set(prev);
        newSet.delete(orderId);
        return newSet;
      });
    }
  };

  const handleNazakStageUpdate = async (orderId) => {
    try {
      setProcessingOrders(prev => new Set([...prev, orderId]));
      setError(null);
      
      const result = await BitrixAPI.updateFromNazakToZakalka(orderId);
  
      if (result && result.success) {
        setNazakOrders(prevOrders => 
          prevOrders.filter(order => order.id !== orderId)
        );
        fetchActiveOrders();
        console.log(`Заказ ${orderId} принят с закалки`);
      } else {
        throw new Error(result?.message || 'Не удалось принять заказ с закалки');
      }
  
    } catch (error) {
      console.error('Ошибка при принятии заказа с закалки:', error);
      setError(`Ошибка при принятии заказа ${orderId}: ${error.message}`);
      alert(`Ошибка: ${error.message}`);
    } finally {
      setProcessingOrders(prev => {
        const newSet = new Set(prev);
        newSet.delete(orderId);
        return newSet;
      });
    }
  };

  // Загрузка деталировки для конкретного заказа
  const loadOrderDetails = async (orderId) => {
    // Проверяем, не загружаются ли уже детали для этого заказа
    if (loadingDetails.has(orderId)) {
      console.log(`⏳ Детали для заказа ${orderId} уже загружаются, пропускаем`);
      return;
    }

    // Отмечаем что начали загрузку
    setLoadingDetails(prev => new Set([...prev, orderId]));

    try {
      console.log(`🔄 Начинаем загрузку деталей для заказа ${orderId}`);
      const token = localStorage.getItem('token');

      // Определяем параметры в зависимости от активной вкладки
      const isReceivingTab = activeTab === "receiving";
      const stageParam = isReceivingTab ? 'zakalka_completed' : 'zakalka';
      const excludeParam = isReceivingTab ? null : 'zakalka_shipped_to_driver';

      const params = {
        stage: stageParam
      };

      if (excludeParam) {
        params.excludeStage = excludeParam;
      }

      // Добавляем параметры для режима приема
      if (isReceivingTab) {
        params.receivingMode = true;
        params.receivingJsonField = 'UF_CRM_3_1752818210443';      // JSON данные для закалки приемка
        params.receivingReportField = 'UF_CRM_3_1752818233225';    // Отчет для закалки приемка
        params.receivingCommentField = 'UF_CRM_3_1752818259434';   // Комментарий ответственного приемка
      }

      const response = await axios.get(`${API_URL}/api/glass-details-fixed/${orderId}`, {
        params: params,
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 30000 // 30 секунд таймаут для каждого запроса деталей
      });

      if (response.data.success) {
        const { glassDetails, savedState } = response.data;
        
        // Инициализируем состояние для заказа
        const selectedIds = new Set();
        const quantities = new Map();
        
        if (savedState && savedState.selected) {
          try {
            const parsedSelected = JSON.parse(savedState.selected);
            if (Array.isArray(parsedSelected)) {
              parsedSelected.forEach(id => selectedIds.add(id));
            }
          } catch (e) {
            console.error('Ошибка парсинга выбранных деталей:', e);
          }
        }
        
        if (savedState && savedState.quantities) {
          try {
            const parsedQuantities = JSON.parse(savedState.quantities);
            Object.entries(parsedQuantities).forEach(([key, value]) => {
              quantities.set(key, parseInt(value) || 1);
            });
          } catch (e) {
            console.error('Ошибка парсинга количеств:', e);
          }
        }

        setOrdersDetails(prev => ({
          ...prev,
          [orderId]: {
            glassDetails: glassDetails || [],
            selectedDetails: selectedIds,
            quantities: quantities
          }
        }));

        setOrdersComments(prev => ({
          ...prev,
          [orderId]: savedState?.responsibleComments || ''
        }));
        
        console.log(`✅ Детали успешно загружены для заказа ${orderId}`);
      }
    } catch (error) {
      console.error(`❌ Ошибка загрузки деталировки для заказа ${orderId}:`, error);
      
      // Создаем пустую структуру данных для заказа, чтобы он всё равно отображался
      setOrdersDetails(prev => ({
        ...prev,
        [orderId]: {
          glassDetails: [],
          selectedDetails: new Set(),
          quantities: new Map(),
          loadError: error.message // Сохраняем информацию об ошибке
        }
      }));
      
      setOrdersComments(prev => ({
        ...prev,
        [orderId]: `Ошибка загрузки деталей: ${error.message}`
      }));
      
      console.log(`⚠️ Заказ ${orderId} будет отображен без деталей из-за ошибки`);
      
      // Перебрасываем ошибку дальше для корректного учета в статистике
      throw error;
    } finally {
      // Убираем заказ из списка загружающихся
      setLoadingDetails(prev => {
        const newSet = new Set(prev);
        newSet.delete(orderId);
        return newSet;
      });
      console.log(`🏁 Завершена загрузка деталей для заказа ${orderId}`);
    }
  };

  // Автосохранение состояния детали на сервере (для конкретной детали)
  const autoSaveDetailState = async (orderId, detailId) => {
    const detailKey = `${orderId}_${detailId}`;

    try {
      // Получаем ТЕКУЩЕЕ состояние заказа из state
      setOrdersDetails(currentOrders => {
        const orderData = currentOrders[orderId];
        if (!orderData) {
          console.log(`⚠️ Нет данных для заказа ${orderId}, пропускаем сохранение`);
          return currentOrders;
        }

        // Устанавливаем статус "сохраняется" для конкретной детали
        setDetailSavingStatus(prev => ({ ...prev, [detailKey]: 'saving' }));

        const selectedArray = Array.from(orderData.selectedDetails);
        const quantitiesObj = Object.fromEntries(orderData.quantities);
        const comments = ordersComments[orderId] || '';

        console.log(`💾 Отправляем на сервер для заказа ${orderId}, деталь ${detailId}:`, {
          selectedDetails: selectedArray,
          selectedQuantities: quantitiesObj,
          totalGlassDetails: orderData.glassDetails?.length || 0
        });

        // Определяем параметры в зависимости от активной вкладки
        const isReceivingTab = activeTab === "receiving";
        const saveData = {
          selectedDetails: selectedArray,
          selectedQuantities: quantitiesObj,
          comments: '',
          unselectedComments: '',
          responsibleComments: comments,
          glassDetails: orderData.glassDetails || [],
          autoSave: true
        };

        if (isReceivingTab) {
          // Для вкладки приема используем поля zakalka_completed
          saveData.stage = 'zakalka_completed';
          saveData.isReceivingMode = true;
          saveData.jsonField = 'UF_CRM_3_1752818210443';
          saveData.reportField = 'UF_CRM_3_1752818233225';
          saveData.commentField = 'UF_CRM_3_1752818259434';
          saveData.bitrixFields = {
            selected: 'UF_CRM_3_1752818210443',
            comments: 'UF_CRM_3_1752818233225',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1752818259434'
          };
        } else {
          // Для вкладки отгрузки используем поля zakalka
          saveData.stage = 'zakalka';
          saveData.isReceivingMode = false;
          saveData.jsonField = 'UF_CRM_3_1751521756206';
          saveData.reportField = 'UF_CRM_3_1751521814271';
          saveData.commentField = 'UF_CRM_3_1751521846111';
          saveData.bitrixFields = {
            selected: 'UF_CRM_3_1751521756206',
            comments: 'UF_CRM_3_1751521814271',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1751521846111'
          };
        }

        const token = localStorage.getItem('token');

        // Выполняем запрос
        fetch(`${API_URL}/api/glass-details/${orderId}/save`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(saveData)
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Ошибка сохранения');
          }
          return response.json();
        })
        .then(data => {
          // Устанавливаем статус "сохранено" для конкретной детали
          setDetailSavingStatus(prev => ({ ...prev, [detailKey]: 'saved' }));
          console.log(`✅ Деталь ${detailId} заказа ${orderId} сохранена на сервере (${saveData.stage})`);

          // Через 2 секунды возвращаем статус в idle
          setTimeout(() => {
            setDetailSavingStatus(prev => {
              const newState = { ...prev };
              delete newState[detailKey];
              return newState;
            });
          }, 2000);
        })
        .catch(error => {
          console.error(`❌ Ошибка сохранения детали ${detailId} заказа ${orderId}:`, error);
          setDetailSavingStatus(prev => ({ ...prev, [detailKey]: 'error' }));

          // Через 3 секунды возвращаем статус в idle
          setTimeout(() => {
            setDetailSavingStatus(prev => {
              const newState = { ...prev };
              delete newState[detailKey];
              return newState;
            });
          }, 3000);
        });

        return currentOrders; // Возвращаем неизменное состояние
      });
    } catch (error) {
      console.error(`❌ Критическая ошибка автосохранения для детали ${detailId} заказа ${orderId}:`, error);
      setDetailSavingStatus(prev => ({ ...prev, [detailKey]: 'error' }));

      setTimeout(() => {
        setDetailSavingStatus(prev => {
          const newState = { ...prev };
          delete newState[detailKey];
          return newState;
        });
      }, 3000);
    }
  };

  // Обработка изменения чекбокса детали с автосохранением
  const handleDetailToggle = (orderId, detailId, detail) => {
    const detailKey = `${orderId}_${detailId}`;

    setOrdersDetails(prev => {
      const orderData = prev[orderId] || { glassDetails: [], selectedDetails: new Set(), quantities: new Map() };
      const newSelectedDetails = new Set(orderData.selectedDetails);
      const newQuantities = new Map(orderData.quantities);

      if (newSelectedDetails.has(detailId)) {
        newSelectedDetails.delete(detailId);
        newQuantities.delete(detailId);
      } else {
        newSelectedDetails.add(detailId);
        newQuantities.set(detailId, detail.quantity || 1);
      }

      const updatedOrderData = {
        ...orderData,
        selectedDetails: newSelectedDetails,
        quantities: newQuantities
      };

      // Отменяем предыдущий таймер автосохранения для этой конкретной детали
      if (saveTimersRef.current[detailKey]) {
        clearTimeout(saveTimersRef.current[detailKey]);
      }

      // Автосохранение с debounce для конкретной детали
      saveTimersRef.current[detailKey] = setTimeout(() => {
        console.log(`🔄 Автосохранение детали ${detailId} заказа ${orderId}`);
        autoSaveDetailState(orderId, detailId);
        delete saveTimersRef.current[detailKey];
      }, 300);

      return {
        ...prev,
        [orderId]: updatedOrderData
      };
    });
  };

  // Обработка изменения количества с автосохранением
  const handleQuantityChange = (orderId, detailId, newQuantity, maxQuantity) => {
    if (newQuantity < 1 || newQuantity > maxQuantity) return;

    const detailKey = `${orderId}_${detailId}`;

    setOrdersDetails(prev => {
      const orderData = prev[orderId] || { glassDetails: [], selectedDetails: new Set(), quantities: new Map() };
      const newQuantities = new Map(orderData.quantities);
      newQuantities.set(detailId, newQuantity);

      const updatedOrderData = {
        ...orderData,
        quantities: newQuantities
      };

      // Отменяем предыдущий таймер автосохранения для этой детали
      if (saveTimersRef.current[detailKey]) {
        clearTimeout(saveTimersRef.current[detailKey]);
      }

      // Автосохранение с debounce для конкретной детали
      saveTimersRef.current[detailKey] = setTimeout(() => {
        console.log(`🔄 Автосохранение изменения количества для детали ${detailId} заказа ${orderId}`);
        autoSaveDetailState(orderId, detailId);
        delete saveTimersRef.current[detailKey];
      }, 500);

      return {
        ...prev,
        [orderId]: updatedOrderData
      };
    });
  };

  // Сохранение заказов с активной вкладки
  const handleSaveAll = async () => {
    try {
      setSavingAll(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      let savedCount = 0;
      let errorCount = 0;
      
      // Получаем список заказов с активной вкладки
      const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;
      const activeOrderIds = currentOrders.map(order => order.id);
      
      console.log(`Начинаем сохранение для вкладки "${activeTab}". Заказов к обработке: ${activeOrderIds.length}`);
      
      for (const orderId of activeOrderIds) {
        try {
          const orderData = ordersDetails[orderId];
          const comments = ordersComments[orderId] || '';
          
          console.log(`Обрабатываем заказ ${orderId}:`, { 
            hasOrderData: !!orderData, 
            selectedDetailsCount: orderData?.selectedDetails?.size || 0,
            activeTab 
          });
          
          if (orderData && orderData.selectedDetails.size > 0) {
            const quantitiesObject = {};
            orderData.quantities.forEach((value, key) => {
              quantitiesObject[key] = value;
            });

            // Определяем поля в зависимости от вкладки
            const saveData = {
              selectedDetails: Array.from(orderData.selectedDetails),
              selectedQuantities: quantitiesObject,
              comments: '',
              unselectedComments: '',
              responsibleComments: comments,
              glassDetails: orderData.glassDetails
            };

            if (activeTab === "receiving") {
              // Для вкладки приема используем поля zakalka_completed
              saveData.stage = 'zakalka_completed';
              saveData.isReceivingMode = true;
              // Используем старые названия полей для совместимости с сервером
              saveData.jsonField = 'UF_CRM_3_1752818210443';      // JSON данные для закалки приемка
              saveData.reportField = 'UF_CRM_3_1752818233225';    // Отчет для закалки приемка
              saveData.commentField = 'UF_CRM_3_1752818259434';   // Комментарий ответственного приемка
              saveData.bitrixFields = {
                selected: 'UF_CRM_3_1752818210443',      // JSON данные для закалки приемка
                comments: 'UF_CRM_3_1752818233225',      // Отчет для закалки приемка
                unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
                responsibleComments: 'UF_CRM_3_1752818259434'  // Комментарий ответственного приемка
              };
              console.log(`Заказ ${orderId}: настройки для режима приемки (zakalka_completed)`, {
                jsonField: saveData.jsonField,
                reportField: saveData.reportField, 
                commentField: saveData.commentField,
                bitrixFields: saveData.bitrixFields
              });
            } else {
              // Для вкладки отгрузки используем поля zakalka
              saveData.stage = 'zakalka';
              saveData.isReceivingMode = false;
              // Используем старые названия полей для совместимости с сервером
              saveData.jsonField = 'UF_CRM_3_1751521756206';      // JSON данные для закалки отгрузка
              saveData.reportField = 'UF_CRM_3_1751521814271';    // Отчет для закалки отгрузка
              saveData.commentField = 'UF_CRM_3_1751521846111';   // Комментарий ответственного отгрузка
              saveData.bitrixFields = {
                selected: 'UF_CRM_3_1751521756206',      // JSON данные для закалки отгрузка
                comments: 'UF_CRM_3_1751521814271',      // Отчет для закалки отгрузка
                unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
                responsibleComments: 'UF_CRM_3_1751521846111'  // Комментарий ответственного отгрузка
              };
              console.log(`Заказ ${orderId}: настройки для режима отгрузки (zakalka)`, {
                jsonField: saveData.jsonField,
                reportField: saveData.reportField,
                commentField: saveData.commentField,
                bitrixFields: saveData.bitrixFields
              });
            }

            console.log(`Отправляем данные для заказа ${orderId}:`, saveData);
            console.log(`🔧 Детальная диагностика для заказа ${orderId}:`);
            console.log(`- Активная вкладка: ${activeTab}`);
            console.log(`- Стадия: ${saveData.stage}`);
            console.log(`- Режим приемки: ${saveData.isReceivingMode}`);
            console.log(`- Поля Bitrix:`, JSON.stringify(saveData.bitrixFields, null, 2));
            console.log(`- Выбранные детали:`, saveData.selectedDetails);
            console.log(`- Количества:`, saveData.selectedQuantities);
            
            const response = await axios.post(`${API_URL}/api/glass-details/${orderId}/save`, saveData, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });

            console.log(`Ответ сервера для заказа ${orderId}:`, response.data);

            if (response.data.success) {
              savedCount++;
              console.log(`✅ Заказ ${orderId} успешно сохранен`);
              
              // Дополнительная информация о сохранении
              if (response.data.savedFields) {
                console.log(`📝 Сохраненные поля для заказа ${orderId}:`, response.data.savedFields);
              }
              if (response.data.updatedFields) {
                console.log(`🔄 Обновленные поля Bitrix для заказа ${orderId}:`, response.data.updatedFields);
              }
              
              // Выводим полный summary для диагностики
              console.log(`📊 Полный summary для заказа ${orderId}:`, JSON.stringify(response.data.summary, null, 2));
              
              // Проверяем, что должно быть сохранено в правильные поля
              console.log(`🎯 ПРОВЕРКА: Для заказа ${orderId} данные должны быть сохранены в поля:`);
              console.log(`- JSON данные в поле: ${saveData.jsonField}`);
              console.log(`- Отчет в поле: ${saveData.reportField}`);
              console.log(`- Комментарий в поле: ${saveData.commentField}`);
              
            } else {
              errorCount++;
              console.error(`❌ Заказ ${orderId} не сохранен:`, response.data);
              console.error(`🔍 Причина ошибки для заказа ${orderId}:`, response.data.error || 'Неизвестная ошибка');
            }
          } else {
            console.log(`⏭️ Заказ ${orderId} пропущен - нет выбранных деталей`);
          }
        } catch (orderError) {
          errorCount++;
          console.error(`❌ Ошибка сохранения заказа ${orderId}:`, orderError);
          console.error('Детали ошибки заказа:', orderError.response?.data);
        }
      }
      
      const message = errorCount > 0 
        ? `Сохранено ${savedCount} заказов. Ошибок: ${errorCount}. Проверьте консоль для деталей.`
        : `Успешно сохранено ${savedCount} заказов`;
      
      alert(message);
      
    } catch (error) {
      console.error('Общая ошибка сохранения:', error);
      console.error('Детали общей ошибки:', error.response?.data);
      setError(`Ошибка сохранения: ${error.response?.data?.error || error.message}`);
    } finally {
      setSavingAll(false);
    }
  };

  // Создание рейса для выбранных заказов
  const handleCreateTrip = async () => {
    try {
      setCreatingTrip(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      
      // Проверяем, что выбраны заказы
      if (selectedOrdersForTrip.size === 0) {
        alert('Выберите заказы для создания рейса');
        return;
      }
      
      // Собираем данные выбранных заказов
      const tripOrders = [];
      const glassSummary = {};
      let totalQuantity = 0;
      let hasSelectedDetails = false;
      
      for (const orderId of selectedOrdersForTrip) {
        const orderData = ordersDetails[orderId];
        const order = activeOrders.find(o => o.id === orderId);
        
        if (orderData && orderData.selectedDetails.size > 0) {
          hasSelectedDetails = true;
          const selectedDetails = [];
          
          orderData.glassDetails.forEach(detail => {
            if (orderData.selectedDetails.has(detail.id)) {
              const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;
              selectedDetails.push({
                ...detail,
                selectedQuantity: quantity
              });
              
              const glassType = detail.glassType || 'Неизвестный тип';
              glassSummary[glassType] = (glassSummary[glassType] || 0) + quantity;
              totalQuantity += quantity;
            }
          });
          
          tripOrders.push({
            orderId: orderId,
            orderNumber: order?.orderNumber || order?.id || orderId,
            orderTitle: order?.title || 'Без названия',
            selectedDetails: selectedDetails,
            comments: ordersComments[orderId] || ''
          });
        }
      }
      
      if (!hasSelectedDetails) {
        alert('Выберите детали в заказах для создания рейса');
        return;
      }
      
      // Сначала сохраняем все выбранные детали
      await handleSaveAll();
      
      // Создаем запись о рейсе
      const batchResponse = await axios.post(`${API_URL}/api/batches`, {
        status: 'created',
        direction: 'to_zakalka',
        orders_data: tripOrders,
        glass_summary: glassSummary,
        total_quantity: totalQuantity,
        created_by: localStorage.getItem('userEmail') || 'unknown'
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (batchResponse.data.success) {
        const batchId = batchResponse.data.batchId;
        
        // Обновляем статус деталей для каждого заказа
        for (const orderId of selectedOrdersForTrip) {
          const orderData = ordersDetails[orderId];
          if (orderData && orderData.selectedDetails.size > 0) {
            try {
              await axios.post(`${API_URL}/api/glass-details/${orderId}/save`, {
                stage: 'zakalka_shipped_to_driver',
                selectedDetails: Array.from(orderData.selectedDetails),
                selectedQuantities: Object.fromEntries(orderData.quantities),
                comments: `Передано в рейс №${batchId}`,
                unselectedComments: '',
                responsibleComments: ordersComments[orderId] || '',
                glassDetails: orderData.glassDetails,
                batchId: batchId
              }, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });
              
              // Переводим заказ на стадию nazak
              await BitrixAPI.updateFromZakalkaToNazak(orderId);
              
            } catch (detailError) {
              console.error(`Ошибка обработки заказа ${orderId}:`, detailError);
            }
          }
        }
        
        // Очищаем выбранные заказы
        setSelectedOrdersForTrip(new Set());
        
        alert(`Рейс №${batchId} создан! Всего деталей: ${totalQuantity}\n\nЗаказов в рейсе: ${tripOrders.length}`);
        
        // Обновляем данные (включая обработанные заказы из БД)
        await fetchActiveOrders();
        await fetchNazakOrders();
        
      } else {
        throw new Error('Не удалось создать рейс');
      }
      
    } catch (error) {
      console.error('Ошибка создания рейса:', error);
      setError(`Ошибка создания рейса: ${error.message}`);
    } finally {
      setCreatingTrip(false);
    }
  };

  // Обработка выбора заказа для рейса
  const handleOrderTripToggle = (orderId) => {
    // Проверяем есть ли ошибка загрузки деталей
    const orderData = ordersDetails[orderId];
    if (orderData && orderData.loadError) {
      alert('Нельзя включить в рейс заказ с ошибкой загрузки деталей. Попробуйте обновить страницу.');
      return;
    }
    
    const newSelected = new Set(selectedOrdersForTrip);
    if (newSelected.has(orderId)) {
      newSelected.delete(orderId);
    } else {
      newSelected.add(orderId);
    }
    setSelectedOrdersForTrip(newSelected);
  };

  // Печать отчетов закалки - генерируем PDF и отправляем на печать
  const handlePrintExistingPDF = async () => {
    try {
      setPrintingPDF(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      
      // Определяем тип отчета и список заказов для текущей вкладки
      const reportType = activeTab === "shipping" ? "отгрузки" : "приемки";
      const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;
      
      // Собираем данные заказов с текущей вкладки (такой же код как в handleGenerateAllPDF)
      const ordersData = [];
      for (const order of currentOrders) {
        const orderId = order.id;
        const orderData = ordersDetails[orderId];
        
        if (orderData && orderData.glassDetails.length > 0) {
          // Группируем ВСЕ детали по типу стекла
          const groupedDetails = {};
          orderData.glassDetails.forEach(detail => {
            const glassType = detail.glassType || 'Неизвестный тип';
            if (!groupedDetails[glassType]) {
              groupedDetails[glassType] = [];
            }
            
            const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;
            const isSelected = orderData.selectedDetails.has(detail.id);
            
            groupedDetails[glassType].push({
              ...detail,
              selectedQuantity: quantity,
              isSelected: isSelected
            });
          });
          
          ordersData.push({
            orderId: orderId,
            orderNumber: order?.orderNumber || order?.id || orderId,
            orderTitle: order?.title || 'Без названия',
            groupedDetails: groupedDetails,
            comments: ordersComments[orderId] || '',
            hasSelectedDetails: orderData.selectedDetails.size > 0
          });
        }
      }
      
      if (ordersData.length === 0) {
        setError(`Нет заказов для печати отчета ${reportType}. Выберите заказы с деталями.`);
        return;
      }
      
      console.log(`Генерируем и печатаем отчет ${reportType} для ${ordersData.length} заказов`);
      
      // Отправляем запрос на сервер для генерации и печати PDF
      const response = await axios.post(
        `${API_URL}/api/generate-and-print-zakalka-pdf`,
        { 
          ordersData,
          reportType: reportType,
          activeTab: activeTab,
          isReceivingMode: activeTab === "receiving",
          bitrixFields: activeTab === "receiving" ? {
            selected: 'UF_CRM_3_1752818210443',      // JSON данные для закалки приемка
            comments: 'UF_CRM_3_1752818233225',      // Отчет для закалки приемка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1752818259434'  // Комментарий ответственного приемка
          } : {
            selected: 'UF_CRM_3_1751521756206',      // JSON данные для закалки отгрузка
            comments: 'UF_CRM_3_1751521814271',      // Отчет для закалки отгрузка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1751521846111'  // Комментарий ответственного отгрузка
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        alert(`Отчет ${reportType} сгенерирован и отправлен на печать!\nЗаказов в отчете: ${ordersData.length}`);
      } else {
        throw new Error(response.data.error || 'Ошибка печати отчета');
      }
      
    } catch (error) {
      console.error('Ошибка печати отчета:', error);
      setError(`Ошибка печати отчета ${reportType}: ${error.message}`);
    } finally {
      setPrintingPDF(false);
    }
  };

  // Генерация партнерского PDF для всех заказов (упрощенная версия)
  const handleGeneratePartnerPDF = async () => {
    try {
      setGeneratingPartnerPDF(true);
      setError(null);

      const token = localStorage.getItem('token');

      // Определяем тип отчета и список заказов для текущей вкладки
      const reportType = activeTab === "shipping" ? "отгрузки" : "приемки";
      const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;

      // Собираем данные заказов с текущей вкладки
      const ordersData = [];
      for (const order of currentOrders) {
        const orderId = order.id;
        const orderData = ordersDetails[orderId];

        if (orderData && orderData.selectedDetails.size > 0) {
          // Группируем ТОЛЬКО ВЫБРАННЫЕ детали по толщине стекла
          const groupedDetails = {};
          orderData.glassDetails.forEach(detail => {
            // Проверяем, что деталь выбрана
            if (!orderData.selectedDetails.has(detail.id)) {
              return; // Пропускаем невыбранные детали
            }

            // Извлекаем толщину из типа стекла или из отдельного поля
            let thickness = 'Неизвестная толщина';
            if (detail.thickness) {
              thickness = detail.thickness;
            } else if (detail.glassType) {
              // Ищем толщину в типе стекла (например "прозрачный 8мм" -> "8мм")
              const thicknessMatch = detail.glassType.match(/(\d+)\s*мм/);
              if (thicknessMatch) {
                thickness = `${thicknessMatch[1]}мм`;
              }
            }

            if (!groupedDetails[thickness]) {
              groupedDetails[thickness] = [];
            }

            const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;

            groupedDetails[thickness].push({
              ...detail,
              selectedQuantity: quantity,
              thickness: thickness,
              glassColor: detail.glassType ? detail.glassType.replace(/\s*\d+\s*мм/g, '').trim() : 'Неизвестный цвет',
              isSelected: true
            });
          });

          ordersData.push({
            orderId: orderId,
            orderNumber: order?.orderNumber || order?.id || orderId,
            orderTitle: order?.title || 'Без названия',
            groupedDetails: groupedDetails,
            // Исключаем комментарии для партнерского отчета
            comments: '',
            hasSelectedDetails: orderData.selectedDetails.size > 0
          });
        }
      }

      if (ordersData.length === 0) {
        alert('Нет заказов для генерации партнерского отчета');
        return;
      }

      // Отправляем запрос на сервер для генерации партнерского PDF
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-partner-pdf`,
        {
          ordersData,
          reportType: reportType,
          activeTab: activeTab,
          isReceivingMode: activeTab === "receiving",
          bitrixFields: activeTab === "receiving" ? {
            selected: 'UF_CRM_3_1752818210443',      // JSON данные для закалки приемка
            comments: 'UF_CRM_3_1752818233225',      // Отчет для закалки приемка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1752818259434'  // Комментарий ответственного приемка
          } : {
            selected: 'UF_CRM_3_1751521756206',      // JSON данные для закалки отгрузка
            comments: 'UF_CRM_3_1751521814271',      // Отчет для закалки отгрузка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1751521846111'  // Комментарий ответственного отгрузка
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Создаем ссылку для скачивания PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `zakalka-partner-${reportType}-${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Ошибка генерации партнерского PDF:', error);
      setError(`Ошибка генерации партнерского PDF: ${error.message}`);
    } finally {
      setGeneratingPartnerPDF(false);
    }
  };

  // Печать партнерского отчета
  const handlePrintPartnerPDF = async () => {
    try {
      setPrintingPartnerPDF(true);
      setError(null);

      const token = localStorage.getItem('token');

      // Определяем тип отчета и список заказов для текущей вкладки
      const reportType = activeTab === "shipping" ? "отгрузки" : "приемки";
      const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;

      // Собираем данные заказов с текущей вкладки (та же логика, что и в handleGeneratePartnerPDF)
      const ordersData = [];
      for (const order of currentOrders) {
        const orderId = order.id;
        const orderData = ordersDetails[orderId];

        if (orderData && orderData.selectedDetails.size > 0) {
          const groupedDetails = {};
          orderData.glassDetails.forEach(detail => {
            if (!orderData.selectedDetails.has(detail.id)) {
              return;
            }

            let thickness = 'Неизвестная толщина';
            if (detail.thickness) {
              thickness = detail.thickness;
            } else if (detail.glassType) {
              const thicknessMatch = detail.glassType.match(/(\d+)\s*мм/);
              if (thicknessMatch) {
                thickness = `${thicknessMatch[1]}мм`;
              }
            }

            if (!groupedDetails[thickness]) {
              groupedDetails[thickness] = [];
            }

            const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;

            groupedDetails[thickness].push({
              ...detail,
              selectedQuantity: quantity,
              thickness: thickness,
              glassColor: detail.glassType ? detail.glassType.replace(/\s*\d+\s*мм/g, '').trim() : 'Неизвестный цвет',
              isSelected: true
            });
          });

          ordersData.push({
            orderId: orderId,
            orderNumber: order?.orderNumber || order?.id || orderId,
            orderTitle: order?.title || 'Без названия',
            groupedDetails: groupedDetails,
            comments: '',
            hasSelectedDetails: orderData.selectedDetails.size > 0
          });
        }
      }

      if (ordersData.length === 0) {
        alert('Нет заказов для печати партнерского отчета');
        return;
      }

      // Генерируем PDF и открываем для печати
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-partner-pdf`,
        {
          ordersData,
          reportType: reportType,
          activeTab: activeTab,
          isReceivingMode: activeTab === "receiving",
          bitrixFields: activeTab === "receiving" ? {
            selected: 'UF_CRM_3_1752818210443',
            comments: 'UF_CRM_3_1752818233225',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1752818259434'
          } : {
            selected: 'UF_CRM_3_1751521756206',
            comments: 'UF_CRM_3_1751521814271',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1751521846111'
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Открываем PDF для печати
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const printWindow = window.open(url, '_blank');

      if (printWindow) {
        printWindow.addEventListener('load', () => {
          printWindow.print();
        });
      } else {
        alert('Не удалось открыть окно для печати. Пожалуйста, разрешите всплывающие окна.');
      }

    } catch (error) {
      console.error('Ошибка печати партнерского PDF:', error);
      setError(`Ошибка печати партнерского PDF: ${error.message}`);
    } finally {
      setPrintingPartnerPDF(false);
    }
  };

  // Функция для подсчета выбранных деталей по толщине стекла
  const calculateGlassSummary = () => {
    const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;
    const summary = {};

    currentOrders.forEach(order => {
      const orderData = ordersDetails[order.id];
      if (orderData) {
        orderData.glassDetails.forEach(detail => {
          // Считаем только выбранные детали
          if (orderData.selectedDetails.has(detail.id)) {
            let thickness = 'Неизвестная';
            if (detail.thickness) {
              thickness = detail.thickness;
            } else if (detail.glassType) {
              const thicknessMatch = detail.glassType.match(/(\d+)\s*мм/);
              if (thicknessMatch) {
                thickness = `${thicknessMatch[1]}мм`;
              }
            }

            if (!summary[thickness]) {
              summary[thickness] = { count: 0, totalArea: 0 };
            }

            const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;
            summary[thickness].count += quantity;

            // Подсчет площади
            if (detail.area) {
              summary[thickness].totalArea += parseFloat(detail.area) * quantity;
            } else if (detail.height && detail.width) {
              const area = (detail.height * detail.width) / 1000000; // мм² в м²
              summary[thickness].totalArea += area * quantity;
            }
          }
        });
      }
    });

    return summary;
  };

  // Генерация PDF для всех заказов
  const handleGenerateAllPDF = async () => {
    try {
      setGeneratingPDF(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      
      // Определяем тип отчета и список заказов для текущей вкладки
      const reportType = activeTab === "shipping" ? "отгрузки" : "приемки";
      const currentOrders = activeTab === "shipping" ? activeOrders : nazakOrders;
      
      // Собираем данные заказов с текущей вкладки
      const ordersData = [];
      for (const order of currentOrders) {
        const orderId = order.id;
        const orderData = ordersDetails[orderId];
        
        if (orderData && orderData.glassDetails.length > 0) {
          // Группируем ВСЕ детали по типу стекла (не только выбранные)
          const groupedDetails = {};
          orderData.glassDetails.forEach(detail => {
            const glassType = detail.glassType || 'Неизвестный тип';
            if (!groupedDetails[glassType]) {
              groupedDetails[glassType] = [];
            }
            
            const quantity = orderData.quantities.get(detail.id) || detail.quantity || 1;
            const isSelected = orderData.selectedDetails.has(detail.id);
            
            groupedDetails[glassType].push({
              ...detail,
              selectedQuantity: quantity,
              isSelected: isSelected // Добавляем информацию о выборе
            });
          });
          
          ordersData.push({
            orderId: orderId,
            orderNumber: order?.orderNumber || order?.id || orderId,
            orderTitle: order?.title || 'Без названия',
            groupedDetails: groupedDetails,
            comments: ordersComments[orderId] || '',
            hasSelectedDetails: orderData.selectedDetails.size > 0
          });
        }
      }
      
      if (ordersData.length === 0) {
        alert('Нет заказов для генерации отчета');
        return;
      }
      
      // Отправляем запрос на сервер для генерации PDF
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-all-pdf`,
        { 
          ordersData,
          reportType: reportType,
          activeTab: activeTab,
          isReceivingMode: activeTab === "receiving",
          bitrixFields: activeTab === "receiving" ? {
            selected: 'UF_CRM_3_1752818210443',      // JSON данные для закалки приемка
            comments: 'UF_CRM_3_1752818233225',      // Отчет для закалки приемка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1752818259434'  // Комментарий ответственного приемка
          } : {
            selected: 'UF_CRM_3_1751521756206',      // JSON данные для закалки отгрузка
            comments: 'UF_CRM_3_1751521814271',      // Отчет для закалки отгрузка
            unselectedComments: 'UF_CRM_3_1749212719306',  // Ответственный за закалку
            responsibleComments: 'UF_CRM_3_1751521846111'  // Комментарий ответственного отгрузка
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Создаем ссылку для скачивания PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `zakalka-${reportType}-${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Ошибка генерации PDF:', error);
      setError(`Ошибка генерации PDF: ${error.message}`);
    } finally {
      setGeneratingPDF(false);
    }
  };

  // Простая проверка заказов в таблице batches
  // Убрана логика проверки batches - показываем все заказы

  const fetchActiveOrders = async (isInitialLoad = false) => {
    try {
      const response = await BitrixAPI.getActiveOrderszakalka();
      const orders = response || [];

      // Определяем новые заказы (которых еще нет в текущем списке)
      const newOrders = orders.filter(newOrder =>
        !activeOrders.some(existingOrder => existingOrder.id === newOrder.id)
      );

      if (newOrders.length > 0 && !isInitialLoad) {
        console.log(`✨ Обнаружено ${newOrders.length} новых заказов закалки:`, newOrders.map(o => o.id));

        // Показываем уведомление о новых заказах
        setNewOrdersNotification({
          count: newOrders.length,
          orderNumbers: newOrders.map(o => o.orderNumber || o.id)
        });

        // Воспроизводим звук уведомления (если доступен)
        try {
          const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBTGH0fPTgjMGHm7A7+OZURE=');
          audio.play().catch(err => console.log('Не удалось воспроизвести звук:', err));
        } catch (err) {
          console.log('Ошибка создания аудио:', err);
        }

        // Автоматически скрываем уведомление через 10 секунд
        setTimeout(() => {
          setNewOrdersNotification(null);
        }, 10000);
      }

      setActiveOrders(orders);

      // Убрана проверка рейсов - показываем все заказы

      // Загружаем деталировку только для новых заказов или всех при первой загрузке
      const ordersToLoadDetails = isInitialLoad ? orders : newOrders;

      if (ordersToLoadDetails.length > 0) {
        console.log('📋 Начинаем параллельную загрузку деталей для', ordersToLoadDetails.length, 'заказов...');
        const detailPromises = ordersToLoadDetails.map(async (order) => {
          try {
            await loadOrderDetails(order.id);
            return { orderId: order.id, success: true };
          } catch (detailError) {
            return { orderId: order.id, success: false, error: detailError.message };
          }
        });

        // Ждем завершения всех запросов (или их таймаутов)
        const detailResults = await Promise.allSettled(detailPromises);
        const successCount = detailResults.filter(r => r.status === 'fulfilled' && r.value.success).length;
        const errorCount = detailResults.length - successCount;

        console.log(`🎯 ИТОГ загрузки деталей: ${successCount} успешно, ${errorCount} с ошибками`);
      }

    } catch (err) {
      console.error("Ошибка загрузки активных заказов закалки:", err);
      setError(`Ошибка загрузки активных заказов: ${err.message}`);
    }
  };

  const fetchNazakOrders = async () => {
    try {
      const response = await BitrixAPI.getNazakOrders();
      const orders = response || [];
      setNazakOrders(orders);

      // Загружаем деталировку для каждого заказа с закалки
      for (const order of orders) {
        await loadOrderDetails(order.id);
      }
    } catch (err) {
      console.error("Ошибка загрузки заказов nazak:", err);
      setError(`Ошибка загрузки заказов nazak: ${err.message}`);
    }
  };

  const fetchTrips = async () => {
    try {
      setLoadingTrips(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки рейсов');
      }

      const data = await response.json();
      console.log('📦 Данные рейсов с сервера:', data);
      console.log('📦 Обработанные рейсы:', data.trips || data);
      const loadedTrips = data.trips || data;
      setTrips(loadedTrips);

      // Загружаем детали для всех рейсов, чтобы показать разбивку по толщине
      for (const trip of loadedTrips) {
        fetchTripDetails(trip.id);
      }
    } catch (err) {
      console.error("Ошибка загрузки рейсов:", err);
      setError(`Ошибка загрузки рейсов: ${err.message}`);
    } finally {
      setLoadingTrips(false);
    }
  };

  // Загрузка деталей конкретного рейса
  const fetchTripDetails = async (tripId) => {
    // Если данные уже есть, возвращаем их
    if (tripDetailsData[tripId]) {
      return tripDetailsData[tripId];
    }

    // Если уже загружается, ждем
    if (loadingTripDetails.has(tripId)) {
      return null;
    }

    try {
      setLoadingTripDetails(prev => new Set(prev).add(tripId));
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки деталей рейса');
      }

      const data = await response.json();
      const details = data.details || [];

      setTripDetailsData(prev => ({
        ...prev,
        [tripId]: details
      }));

      return details; // Возвращаем данные
    } catch (err) {
      console.error(`Ошибка загрузки деталей рейса ${tripId}:`, err);
      return null;
    } finally {
      setLoadingTripDetails(prev => {
        const newSet = new Set(prev);
        newSet.delete(tripId);
        return newSet;
      });
    }
  };

  // Загрузка деталей которые в активных рейсах
  const fetchDetailsInTrips = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips-details-in-use`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки деталей в рейсах');
      }

      const data = await response.json();
      if (data.success && data.details) {
        // Создаем Set из ключей orderId_detailId
        const detailsSet = new Set(
          data.details.map(d => `${d.orderId}_${d.detailId}`)
        );
        setDetailsInTrips(detailsSet);
      }
    } catch (err) {
      console.error("Ошибка загрузки деталей в рейсах:", err);
    }
  };


  // Вставка поиска и счётчика в хедер
  useEffect(() => {
    setHeaderExtras(
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <input
          type="text"
          placeholder="Поиск по номеру, названию..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          style={{ width: "220px" }}
        />
        <span className="text-sm text-gray-600">
          Заказов: <strong>{activeOrders.length}</strong>
        </span>
      </div>
    );
    return () => setHeaderExtras(null);
  }, [searchQuery, activeOrders.length]);

  // Первоначальная загрузка всех заказов при монтировании компонента
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Загружаем только рейсы при открытии страницы
        // Заказы и детали загружаются при открытии модального окна создания рейса
        await Promise.all([
          fetchTrips(),
          fetchDetailsInTrips()
        ]);

      } catch (err) {
        console.error("Ошибка загрузки данных:", err);
        setError(`Ошибка загрузки: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []); // Загружаем только один раз при монтировании

  // Polling для автоматического обновления заказов
  useEffect(() => {
    if (!isPollingActive || activeTab !== 'shipping') {
      return;
    }

    const pollingInterval = setInterval(() => {
      console.log('🔄 Проверка новых заказов закалки...');
      fetchActiveOrders(false);
    }, 30000); // Проверяем каждые 30 секунд

    return () => {
      clearInterval(pollingInterval);
    };
  }, [isPollingActive, activeTab, activeOrders]);

  // Эффект для инициализации данных модального окна при открытии
  useEffect(() => {
    if (!showViewTripModal || !viewingTrip) return;

    const loadDetails = async () => {
      try {
        // Для этапа приёмки всегда сбрасываем кэш, чтобы получить свежие received_quantity
        if (viewingTrip.status === 'received_from_partner') {
          setTripDetailsData(prev => {
            const newData = { ...prev };
            delete newData[viewingTrip.id];
            return newData;
          });
        }

        const details = await fetchTripDetails(viewingTrip.id);

        if (details && details.length > 0) {
          const initialReceivedDetails = {};
          details.forEach(detail => {
            initialReceivedDetails[detail.id] = 
              detail.received_quantity !== null && detail.received_quantity !== undefined 
                ? detail.received_quantity 
                : 0;
          });
          setReceivedDetails(initialReceivedDetails);
        }
      } catch (err) {
        console.error("Ошибка загрузки деталей рейса в модалке просмотра:", err);
      }
    };

    loadDetails();
  }, [showViewTripModal, viewingTrip]);

  // Получаем уникальные толщины из деталей рейса (для фильтра)
  const availableThicknesses = React.useMemo(() => {
    const thicknesses = new Set();
    tripDetails.forEach(detail => {
      let thickness = null;
      if (detail.thickness) {
        thickness = detail.thickness;
      } else if (detail.glassType) {
        const match = detail.glassType.match(/(\d+)\s*мм/i);
        if (match) thickness = match[1] + 'мм';
      }
      if (thickness) thicknesses.add(thickness);
    });
    return Array.from(thicknesses).sort((a, b) => parseInt(a) - parseInt(b));
  }, [tripDetails]);


  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setError(null);
  };

  const renderGlassDetails = (orderId, orderNumber) => {
    const orderData = ordersDetails[orderId];
    
    // Если есть ошибка загрузки, показываем специальное сообщение
    if (orderData && orderData.loadError) {
      return (
        <div className="text-center py-4">
          <div className="text-red-500 mb-2">
            ⚠️ Ошибка загрузки деталей: {orderData.loadError}
          </div>
          <div className="text-gray-500 text-sm">
            Заказ отображается в упрощенном режиме. Попробуйте обновить страницу.
          </div>
        </div>
      );
    }
    
    if (!orderData || !orderData.glassDetails.length) {
      return (
        <div className="text-center py-4 text-gray-500">
          Нет доступных деталей для выбора (либо сверловщик еще не выбрал детали, либо все детали уже переданы водителю)
        </div>
      );
    }

    // Фильтруем детали которые уже в рейсах (только на вкладке отгрузки)
    let availableDetails = orderData.glassDetails;
    if (activeTab === 'shipping') {
      availableDetails = orderData.glassDetails.filter(detail => {
        const key = `${orderId}_${detail.id}`;
        return !detailsInTrips.has(key);
      });
    }

    // Если после фильтрации не осталось деталей
    if (availableDetails.length === 0 && activeTab === 'shipping') {
      return (
        <div className="text-center py-4 text-gray-500">
          Все детали этого заказа уже в рейсах
        </div>
      );
    }

    // Группируем детали по типу стекла
    const groupedDetails = {};
    availableDetails.forEach(detail => {
      const glassType = detail.glassType || 'Неизвестный тип';
      if (!groupedDetails[glassType]) {
        groupedDetails[glassType] = [];
      }
      groupedDetails[glassType].push(detail);
    });

    return (
      <div className="space-y-4">
        {Object.entries(groupedDetails).map(([glassType, details]) => (
          <div key={glassType} className="border border-gray-200 rounded-lg p-3">
            <h4 className="text-xs sm:text-sm font-medium text-gray-800 mb-2">{glassType}</h4>
            <div className="space-y-2">
              {details.map((detail) => {
                const isSelected = orderData.selectedDetails.has(detail.id);
                const selectedQuantity = orderData.quantities.get(detail.id) || detail.quantity || 1;
                const maxQuantity = detail.quantity || 1;
                const isReceivingTab = activeTab === "receiving";
                const isDisabled = false; // Убираем ограничение - разрешаем свободный выбор
                
                return (
                  <div
                    key={detail.id}
                    className={`flex items-center justify-between p-2 border rounded ${
                      isSelected ? 'border-green-300 bg-green-50' :
                      isDisabled ? 'border-gray-200 bg-gray-100 opacity-50' :
                      'border-gray-200 bg-gray-50'
                    }`}
                  >
                    <div className="flex items-center space-x-3 flex-1">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => !isDisabled && handleDetailToggle(orderId, detail.id, detail)}
                        disabled={isDisabled}
                        className={`h-4 w-4 text-green-600 rounded ${
                          isDisabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                      />
                      <div className="flex-1">
                        <div className={`text-xs sm:text-sm ${
                          isDisabled ? 'text-gray-400' : 'font-medium'
                        }`}>
                          {detail.originalText}
                          <span className="ml-1 sm:ml-2 px-1.5 sm:px-2 py-0.5 sm:py-1 text-xs bg-blue-100 text-blue-800 rounded-full">
                            №{orderNumber}
                          </span>
                          <span className="ml-2">
                            <SaveStatusIndicator orderId={orderId} detailId={detail.id} />
                          </span>
                        </div>
{/* Дополнительная информация о детали скрыта для экономии места
                        <div className={`text-xs ${
                          isDisabled ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                          {detail.height && detail.width && (
                            <span className="mr-3">
                              {detail.height}×{detail.width}мм
                            </span>
                          )}
                          <span>Макс: {maxQuantity}шт</span>
                          {detail.area && (
                            <span className="ml-3">Площадь: {detail.area} м²</span>
                          )}
                        </div>
                        */}
                      </div>
                    </div>
                    
                    {isSelected && (
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => handleQuantityChange(orderId, detail.id, selectedQuantity - 1, maxQuantity)}
                          disabled={selectedQuantity <= 1 || isDisabled}
                          className="w-6 h-6 rounded bg-red-100 hover:bg-red-200 text-red-600 text-sm font-bold disabled:opacity-50"
                        >
                          −
                        </button>
                        <span className="text-sm font-medium min-w-[2rem] text-center">
                          {selectedQuantity}
                        </span>
                        <button
                          onClick={() => handleQuantityChange(orderId, detail.id, selectedQuantity + 1, maxQuantity)}
                          disabled={selectedQuantity >= maxQuantity || isDisabled}
                          className="w-6 h-6 rounded bg-green-100 hover:bg-green-200 text-green-600 text-sm font-bold disabled:opacity-50"
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Функция для рендеринга только деталей без карточек заказов
  const renderDetailsOnly = (ordersList) => {
    const allDetails = [];
    
    // Применяем поиск к списку заказов
    const filteredOrders = filterOrders(ordersList);
    
    // Собираем все детали из отфильтрованных заказов
    filteredOrders.forEach(order => {
      const orderData = ordersDetails[order.id];
      if (orderData && orderData.glassDetails) {
        orderData.glassDetails.forEach(detail => {
          // На вкладке отгрузки пропускаем детали которые уже в рейсах
          if (activeTab === 'shipping') {
            const key = `${order.id}_${detail.id}`;
            if (detailsInTrips.has(key)) {
              return; // Пропускаем эту деталь
            }
          }

          allDetails.push({
            ...detail,
            orderId: order.id,
            orderNumber: order.orderNumber || order.id,
            orderTitle: order.title,
            isSelected: orderData.selectedDetails.has(detail.id),
            selectedQuantity: orderData.quantities.get(detail.id) || detail.quantity || 1,
            maxQuantity: detail.quantity || 1
          });
        });
      }
    });

    // Дополнительная фильтрация деталей по поисковому запросу
    let filteredDetails = allDetails;
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filteredDetails = allDetails.filter(detail => [
        detail.originalText,
        detail.glassType,
        detail.height?.toString(),
        detail.width?.toString(),
        detail.orderNumber?.toString(),
        detail.orderTitle
      ].some(field => field?.toLowerCase().includes(query)));
    }

    // Группируем отфильтрованные детали по типу стекла
    const groupedDetails = {};
    filteredDetails.forEach(detail => {
      const glassType = detail.glassType || 'Неизвестный тип';
      if (!groupedDetails[glassType]) {
        groupedDetails[glassType] = [];
      }
      groupedDetails[glassType].push(detail);
    });

    if (filteredDetails.length === 0) {
      return (
        <div className="text-center py-8 text-gray-500">
          {searchQuery.trim() 
            ? `Не найдено деталей по запросу "${searchQuery}"`
            : "Нет доступных деталей для отображения"
          }
        </div>
      );
    }

    return (
      <div className="space-y-6">
        {Object.entries(groupedDetails).map(([glassType, details]) => (
          <div key={glassType} className="border border-gray-200 rounded-lg p-4">
            <h3 className="text-sm sm:text-base font-medium text-gray-800 mb-3">{glassType}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {details.map((detail) => (
                <div
                  key={`${detail.orderId}_${detail.id}`}
                  className={`p-2 sm:p-3 border rounded-lg ${
                    detail.isSelected ? 'border-green-300 bg-green-50' : 'border-gray-200 bg-gray-50'
                  }`}
                >
                  <div className="flex items-start justify-between mb-1 sm:mb-2">
                    <div className="flex items-center space-x-1 sm:space-x-2">
                      <input
                        type="checkbox"
                        checked={detail.isSelected}
                        onChange={() => handleDetailToggle(detail.orderId, detail.id, detail)}
                        className="h-3 w-3 sm:h-4 sm:w-4 text-green-600 rounded"
                      />
                      <span className="text-xs bg-blue-100 text-blue-800 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full">
                        №{detail.orderNumber}
                      </span>
                      <SaveStatusIndicator orderId={detail.orderId} detailId={detail.id} />
                    </div>
                    {detail.isSelected && (
                      <div className="flex items-center space-x-0.5 sm:space-x-1">
                        <button
                          onClick={() => handleQuantityChange(detail.orderId, detail.id, detail.selectedQuantity - 1, detail.maxQuantity)}
                          disabled={detail.selectedQuantity <= 1}
                          className="w-4 h-4 sm:w-5 sm:h-5 rounded bg-red-100 hover:bg-red-200 text-red-600 text-xs font-bold disabled:opacity-50"
                        >
                          −
                        </button>
                        <span className="mx-1 sm:mx-2 min-w-[1.5rem] sm:min-w-[2rem] text-center text-xs sm:text-sm font-medium">
                          {detail.selectedQuantity}
                        </span>
                        <button
                          onClick={() => handleQuantityChange(detail.orderId, detail.id, detail.selectedQuantity + 1, detail.maxQuantity)}
                          disabled={detail.selectedQuantity >= detail.maxQuantity}
                          className="w-4 h-4 sm:w-5 sm:h-5 rounded bg-green-100 hover:bg-green-200 text-green-600 text-xs font-bold disabled:opacity-50"
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="text-xs sm:text-sm font-medium text-gray-900 mb-1">
                    {detail.originalText}
                  </div>

                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Функция умного поиска по всем полям
  const filterOrders = (ordersList) => {
    if (!Array.isArray(ordersList)) return [];
    if (!searchQuery.trim()) return ordersList;
    
    const query = searchQuery.toLowerCase().trim();
    
    return ordersList.filter(order => {
      // Поиск по основным полям заказа
      const orderMatches = [
        order.orderNumber?.toString(),
        order.id?.toString(),
        order.title,
        order.createdDate
      ].some(field => field?.toLowerCase().includes(query));
      
      // Поиск по деталировке
      const orderDetails = ordersDetails[order.id];
      const detailsMatch = orderDetails?.glassDetails?.some(detail => [
        detail.originalText,
        detail.glassType,
        detail.height?.toString(),
        detail.width?.toString(),
        detail.area?.toString(),
        `${detail.height}x${detail.width}`, // Поиск по размерам в формате "высота x ширина"
        `${detail.height}×${detail.width}`, // То же с символом умножения
        detail.quantity?.toString()
      ].some(field => field?.toLowerCase().includes(query)));
      
      // Поиск по комментариям
      const commentsMatch = ordersComments[order.id]?.toLowerCase().includes(query);
      
      return orderMatches || detailsMatch || commentsMatch;
    });
  };

  const renderOrdersList = (ordersList, isNazakTab = false) => {
    if (!Array.isArray(ordersList) || ordersList.length === 0) {
      return (
        <div className="bg-white p-4 shadow rounded-lg">
          <p className="text-gray-600">Нет заказов для отображения</p>
        </div>
      );
    }

    // Применяем фильтрацию по поиску
    let availableOrders = filterOrders(ordersList);

    // На вкладке отгрузки фильтруем заказы у которых все детали уже в рейсах
    if (activeTab === 'shipping') {
      availableOrders = availableOrders.filter(order => {
        const orderData = ordersDetails[order.id];
        if (!orderData || !orderData.glassDetails || orderData.glassDetails.length === 0) {
          return true; // Показываем заказы без деталей
        }

        // Проверяем есть ли хотя бы одна деталь не в рейсе
        const hasAvailableDetails = orderData.glassDetails.some(detail => {
          const key = `${order.id}_${detail.id}`;
          return !detailsInTrips.has(key);
        });

        return hasAvailableDetails;
      });
    }
    
    if (availableOrders.length === 0) {
      const hasSearchQuery = searchQuery.trim();
      return (
        <div className="bg-white p-4 shadow rounded-lg">
          <p className="text-gray-600">
            {hasSearchQuery 
              ? `Не найдено заказов по запросу "${searchQuery}"` 
              : "Нет заказов для отображения"}
          </p>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        {availableOrders.map((order) => {
          const isSelected = selectedOrdersForTrip.has(order.id);
          const hasSelectedDetails = ordersDetails[order.id]?.selectedDetails?.size > 0;
          const hasLoadError = ordersDetails[order.id]?.loadError;
          
          return (
            <div 
              key={order.id} 
              className={`p-4 shadow rounded-lg bg-white ${
                isSelected ? 'ring-2 ring-green-300' : ''
              }`}
            >
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 space-y-4 sm:space-y-0">
                <div className="flex items-center space-x-3">
                  <div>
                    <h2 className="text-sm sm:text-base font-medium">
                      Заказ №{order.orderNumber || order.id}
                      {hasLoadError && (
                        <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-1 rounded">
                          ⚠️ Ошибка деталей
                        </span>
                      )}
                    </h2>
                    <p className="text-xs sm:text-sm text-gray-600">{order.title}</p>
                    <p className="text-xs text-gray-500">ID: {order.id}</p>
                    {order.createdDate && (
                      <p className="text-xs text-gray-500">
                        Дата отправки: {order.createdDate}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                  {/* Кнопка показа чертежей */}
                  {(order.productionFiles?.length > 0 || order.files?.length > 0) && (
                    <button
                      onClick={() => setShowFilesForOrder(showFilesForOrder === order.id ? null : order.id)}
                      className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs transition-colors w-full sm:w-auto"
                    >
                      {showFilesForOrder === order.id ? 'Скрыть' : 'Файлы'}
                    </button>
                  )}
                  
                  {/* Основная кнопка действия - только для nazak заказов */}
                  {isNazakTab && (
                    <div className="w-full sm:w-64">
                      <SwipeToConfirmButton
                        orderId={order.id}
                        onConfirm={handleNazakStageUpdate}
                        isLoading={processingOrders.has(order.id)}
                        buttonText="Свайп для приема"
                        completedText="Отпустите для приема"
                        processingText="Принимаем..."
                      />
                    </div>
                  )}
                  {/* Основная кнопка действия - только для отгрузки заказов */}
                  {activeTab === "shipping" && !isNazakTab && (
                    <div className="w-full sm:w-64">
                      <SwipeToConfirmButton
                        orderId={order.id}
                        onConfirm={handleStageUpdate}
                        isLoading={processingOrders.has(order.id)}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Файлы (показываются по кнопке) */}
              {showFilesForOrder === order.id && (
                <div className="mb-4 space-y-4">
                  {order.productionFiles && order.productionFiles.length > 0 && (
                    <div>
                      <h3 className="text-sm text-gray-800 mb-2">Чертежи для производства:</h3>
                      {order.productionFiles.map((file) => (
                        <FilePreview 
                          key={file.id} 
                          file={file} 
                          dealId={order.id}
                        />
                      ))}
                    </div>
                  )}

                  {order.files && order.files.length > 0 && (
                    <div>
                      <h3 className="text-sm text-gray-800 mb-2">Деталировка к чертежу:</h3>
                      {order.files.map((file) => (
                        <FilePreview 
                          key={file.id} 
                          file={file} 
                          dealId={order.id}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Деталировка стекла (видна на обеих вкладках) */}
              {(activeTab === "shipping" || activeTab === "receiving") && (
                <div>
                  <h3 className="text-sm sm:text-base font-medium mb-2">
                    {activeTab === "shipping" ? "Деталировка закалки:" : "Деталировка для принятия с закалки:"}
                  </h3>
                  {renderGlassDetails(order.id, order.orderNumber || order.id)}
                  
                  {/* Информация от водителя */}
                  <DriverDeliveryInfo deliveryInfo={order.deliveryInfo} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // Функция для генерации партнерского отчета из модального окна создания рейса
  const handleGenerateTripPartnerPDF = async () => {
    try {
      setGeneratingPartnerPDF(true);
      setError(null);

      const token = localStorage.getItem('token');

      // Фильтруем только выбранные детали
      const selectedDetails = tripDetails.filter(d => d.isSelected);

      if (selectedDetails.length === 0) {
        alert('Нет выбранных деталей для генерации отчета партнера');
        setGeneratingPartnerPDF(false);
        return;
      }

      // Группируем детали по заказам
      const orderGroups = {};
      selectedDetails.forEach(detail => {
        if (!orderGroups[detail.orderId]) {
          orderGroups[detail.orderId] = {
            orderId: detail.orderId,
            orderNumber: detail.orderNumber,
            orderTitle: 'Рейс', // Можно добавить название если нужно
            details: []
          };
        }
        orderGroups[detail.orderId].details.push(detail);
      });

      // Подготавливаем данные для отчета
      const ordersData = Object.values(orderGroups).map(orderGroup => {
        // Группируем детали по толщине стекла
        const groupedDetails = {};

        orderGroup.details.forEach(detail => {
          // Извлекаем толщину из типа стекла
          let thickness = 'Неизвестная толщина';
          if (detail.glassType) {
            const thicknessMatch = detail.glassType.match(/(\d+)\s*мм/);
            if (thicknessMatch) {
              thickness = `${thicknessMatch[1]}мм`;
            }
          }

          if (!groupedDetails[thickness]) {
            groupedDetails[thickness] = [];
          }

          groupedDetails[thickness].push({
            id: detail.detailId,
            originalText: detail.detailText,
            glassType: detail.glassType,
            height: detail.height,
            width: detail.width,
            area: detail.area,
            selectedQuantity: detail.quantity,
            thickness: thickness,
            glassColor: detail.glassType ? detail.glassType.replace(/\s*\d+\s*мм/g, '').trim() : 'Неизвестный цвет',
            isSelected: true
          });
        });

        return {
          orderId: orderGroup.orderId,
          orderNumber: orderGroup.orderNumber,
          orderTitle: orderGroup.orderTitle,
          groupedDetails: groupedDetails,
          comments: '',
          hasSelectedDetails: true
        };
      });

      // Определяем тип отчета на основе типа рейса
      const reportType = editingTrip?.type === 'shipping' ? 'отгрузки' : 'приемки';

      // Отправляем запрос на сервер для генерации партнерского PDF
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-partner-pdf`,
        {
          ordersData,
          reportType: reportType,
          activeTab: editingTrip?.type === 'shipping' ? 'shipping' : 'receiving',
          isReceivingMode: editingTrip?.type !== 'shipping',
          bitrixFields: editingTrip?.type !== 'shipping' ? {
            selected: 'UF_CRM_3_1752818210443',
            comments: 'UF_CRM_3_1752818233225',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1752818259434'
          } : {
            selected: 'UF_CRM_3_1751521756206',
            comments: 'UF_CRM_3_1751521814271',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1751521846111'
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Создаем ссылку для скачивания PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `partner_report_${reportType}_${new Date().toLocaleDateString('ru-RU')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Ошибка генерации партнерского PDF:', error);
      alert('Ошибка при генерации партнерского отчета');
    } finally {
      setGeneratingPartnerPDF(false);
    }
  };

  // Функция для создания рейса из выбранных деталей
  const handleCreateTripFromSelected = async (type) => {
    // Сначала открываем модальное окно с индикатором загрузки
    setEditingTrip({
      type: type,
      status: 'saved',
      notes: '',
      partner: tripPartner,
      details: []
    });
    setTripDetails([]);
    setAvailableDetails([]);
    setTripDetailsSearch('');
    setAvailableDetailsSearch('');
    setLoadingTripDetailsInModal(true); // Показываем индикатор загрузки
    setLoadingAvailableDetailsInModal(false);
    setEditModalTab('details');
    setShowEditModal(true);

    try {
      const token = localStorage.getItem('token');

      // Параллельно загружаем: заказы, детали в использовании
      const [ordersResponse, usedDetailsResponse] = await Promise.all([
        BitrixAPI.getActiveOrderszakalka(),
        fetch(`${API_BASE_URL}/api/zakalka-trips-details-in-use`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);

      const orders = ordersResponse || [];
      setActiveOrders(orders);

      // Собираем детали, которые уже в рейсах
      let usedDetails = new Set();
      if (usedDetailsResponse.ok) {
        const data = await usedDetailsResponse.json();
        if (data.success && data.details && Array.isArray(data.details)) {
          data.details.forEach(detail => {
            const key = `${detail.orderId}_${detail.detailId}`;
            usedDetails.add(key);
          });
        }
      }

      // Загружаем детали для каждого заказа
      console.log('📋 Загрузка деталей для', orders.length, 'заказов...');
      const loadedOrdersDetails = {};

      await Promise.all(orders.map(async (order) => {
        try {
          const detailsResponse = await axios.get(`${API_BASE_URL}/api/glass-details-fixed/${order.id}`, {
            headers: { 'Authorization': `Bearer ${token}` },
            params: { stage: 'zakalka' },
            timeout: 30000
          });

          if (detailsResponse.data.success) {
            loadedOrdersDetails[order.id] = {
              glassDetails: detailsResponse.data.glassDetails || [],
              quantities: new Map(),
              selectedDetails: new Set()
            };
          }
        } catch (err) {
          console.error(`Ошибка загрузки деталей заказа ${order.id}:`, err);
        }
      }));

      // Обновляем ordersDetails
      setOrdersDetails(prev => ({ ...prev, ...loadedOrdersDetails }));

      // Собираем ВСЕ детали, исключая уже добавленные в рейсы
      const allDetails = [];

      Object.entries(loadedOrdersDetails).forEach(([orderId, orderData]) => {
        if (orderData.glassDetails && orderData.glassDetails.length > 0) {
          const order = orders.find(o => o.id == orderId || String(o.id) === String(orderId));
          if (!order) return;

          orderData.glassDetails.forEach(detail => {
            const detailKey = `${orderId}_${detail.id}`;
            if (usedDetails.has(detailKey)) return;

            allDetails.push({
              orderId: orderId,
              orderNumber: order.orderNumber || order.id,
              detailId: detail.id,
              detailText: detail.originalText,
              glassType: detail.glassType,
              height: detail.height,
              width: detail.width,
              area: detail.area,
              quantity: detail.quantity || 1,
              maxQuantity: detail.quantity || 1,
              isSelected: false
            });
          });
        }
      });

      if (allDetails.length === 0) {
        setLoadingTripDetailsInModal(false);
        alert('Нет доступных деталей для создания рейса. Все детали уже добавлены в существующие рейсы.');
        setShowEditModal(false);
        setEditingTrip(null);
        setTripDetailsThicknessFilter('all');
        return;
      }

      // Устанавливаем загруженные детали
      setEditingTrip(prev => ({ ...prev, details: allDetails }));
      setTripDetails(allDetails);
      setLoadingTripDetailsInModal(false);

      console.log(`✅ Загружено ${allDetails.length} деталей для создания рейса`);

    } catch (error) {
      console.error('Ошибка при загрузке данных:', error);
      setLoadingTripDetailsInModal(false);
      alert('Ошибка при загрузке заказов и деталей');
    }
  };

  // Функция сохранения рейса
  const handleSaveTrip = async () => {
    try {
      setCreatingTrip(true);
      const token = localStorage.getItem('token');

      // Подготовка данных - фильтруем только выбранные детали (с галочкой)
      const selectedDetails = tripDetails.filter(d => d.isSelected);

      if (selectedDetails.length === 0) {
        alert('Пожалуйста, выберите хотя бы одну деталь для создания рейса (поставьте галочку)');
        setCreatingTrip(false);
        return;
      }

      const uniqueOrders = new Set(selectedDetails.map(d => d.orderId));
      const tripData = {
        type: editingTrip.type,
        partner: tripPartner,
        status: editingTrip.status,
        notes: editingTrip.notes,
        details: selectedDetails.map(d => ({
          order_id: d.orderId,
          order_number: d.orderNumber,
          detail_id: d.detailId,
          detail_text: d.detailText,
          glass_type: d.glassType,
          quantity: d.quantity
        })),
        totalOrders: uniqueOrders.size,
        totalDetails: selectedDetails.reduce((sum, d) => sum + (d.quantity || 1), 0)
      };

      let response;
      let isUpdate = editingTrip.id;

      if (isUpdate) {
        // Обновление существующего рейса
        response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${editingTrip.id}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(tripData)
        });
      } else {
        // Создание нового рейса
        response = await fetch(`${API_BASE_URL}/api/zakalka-trips`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(tripData)
        });
      }

      if (!response.ok) {
        throw new Error('Ошибка сохранения рейса');
      }

      const savedTrip = await response.json();

      // Перезагружаем список рейсов и деталей в рейсах
      await Promise.all([
        fetchTrips(),
        fetchDetailsInTrips()
      ]);

      // Закрываем модальное окно
      setShowEditModal(false);
      setShowTripModal(false);
      setEditingTrip(null);
      setTripPartner('Казстековид');
      setTripDetails([]);
      setTripDetailsThicknessFilter('all');

      // Очищаем выбранные детали только при создании нового рейса
      if (!isUpdate) {
        setOrdersDetails(prev => {
          const newState = { ...prev };
          Object.keys(newState).forEach(orderId => {
            newState[orderId].selectedDetails.clear();
            newState[orderId].quantities.clear();
          });
          return newState;
        });
      }

      const action = isUpdate ? 'обновлен' : 'создан';
      alert(`Рейс ${savedTrip.trip_number} успешно ${action}!`);
    } catch (err) {
      console.error("Ошибка сохранения рейса:", err);
      alert(`Ошибка при сохранении рейса: ${err.message}`);
    } finally {
      setCreatingTrip(false);
    }
  };

  // Функция отгрузки рейса
  const handleShipTrip = async (tripId) => {
    if (!confirm('Отгрузить этот рейс?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/ship`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка отгрузки рейса');
      }

      await fetchTrips();
      alert('Рейс успешно отгружен!');
    } catch (err) {
      console.error("Ошибка отгрузки рейса:", err);
      alert(`Ошибка при отгрузке рейса: ${err.message}`);
    }
  };

  // Функция приема рейса
  const handleReceiveTrip = async (tripId) => {
    if (!confirm('Принять этот рейс?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/receive`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка приема рейса');
      }

      await fetchTrips();
      alert('Рейс успешно принят!');
    } catch (err) {
      console.error("Ошибка приема рейса:", err);
      alert(`Ошибка при приеме рейса: ${err.message}`);
    }
  };

  // Функция принятия рейса водителем
  const handleAcceptByDriver = async (tripId) => {
    if (!confirm('Принять рейс в работу?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/accept-by-driver`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка принятия рейса');
      }

      await fetchTrips();
      alert('Рейс принят в работу!');
    } catch (err) {
      console.error("Ошибка принятия рейса:", err);
      alert(`Ошибка при принятии рейса: ${err.message}`);
    }
  };

  // Функция сдачи партнеру
  const handleDeliverToPartner = async (tripId) => {
    if (!confirm('Сдать рейс партнеру?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/deliver-to-partner`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка сдачи партнеру');
      }

      await fetchTrips();
      alert('Рейс сдан партнеру!');
    } catch (err) {
      console.error("Ошибка сдачи партнеру:", err);
      alert(`Ошибка при сдаче партнеру: ${err.message}`);
    }
  };

  // Функция забора у партнера
  const handleReceiveFromPartner = async (tripId) => {
    if (!confirm('Забрать рейс у партнера?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/receive-from-partner`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка забора у партнера');
      }

      await fetchTrips();
      alert('Рейс забран у партнера!');
    } catch (err) {
      console.error("Ошибка забора у партнера:", err);
      alert(`Ошибка при заборе у партнера: ${err.message}`);
    }
  };

  // Функция финального приема с закалки
  const handleReceiveFromZakalka = async (tripId) => {
    // Подготавливаем массив деталей которые приехали
    const details = tripDetailsData[tripId] || [];
    const receivedDetailsList = details.map(detail => {
      const receivedQty = receivedDetails[detail.id] ?? detail.quantity; // Используем уникальный ID из БД
      return {
        detailId: detail.id, // Отправляем ID записи из zakalka_trip_details
        receivedQuantity: receivedQty,
        totalQuantity: detail.quantity
      };
    }).filter(d => d.receivedQuantity > 0); // Только детали с количеством > 0

    // Проверяем что хотя бы одна деталь отмечена как приехавшая
    if (receivedDetailsList.length === 0) {
      alert('Необходимо отметить хотя бы одну деталь!');
      return;
    }

    const notReceivedCount = details.length - receivedDetailsList.length;
    const confirmMessage = notReceivedCount > 0
      ? `Принять рейс с закалки?\n\nПриехало деталей: ${receivedDetailsList.length}\nНе приехало: ${notReceivedCount}`
      : 'Принять рейс с закалки? Все детали отмечены как приехавшие.';

    if (!confirm(confirmMessage)) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}/receive-from-zakalka`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ receivedDetails: receivedDetailsList })
      });

      if (!response.ok) {
        throw new Error('Ошибка приема с закалки');
      }

      // Очищаем состояние деталей
      setReceivedDetails({});

      // Перезагружаем список рейсов и деталей в рейсах (детали освобождаются)
      await Promise.all([
        fetchTrips(),
        fetchDetailsInTrips()
      ]);
      alert('Рейс принят с закалки!');
    } catch (err) {
      console.error("Ошибка приема с закалки:", err);
      alert(`Ошибка при приеме с закалки: ${err.message}`);
    }
  };

  // Функция удаления рейса
  const handleDeleteTrip = async (tripId) => {
    if (!confirm('Удалить этот черновик рейса?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка удаления рейса');
      }

      // Перезагружаем список рейсов и деталей в рейсах (детали освобождаются)
      await Promise.all([
        fetchTrips(),
        fetchDetailsInTrips()
      ]);
      alert('Рейс успешно удален!');
    } catch (err) {
      console.error("Ошибка удаления рейса:", err);
      alert(`Ошибка при удалении рейса: ${err.message}`);
    }
  };

  // Функция автоматического сохранения отметки о принятой детали
  const saveDetailReceived = async (uniqueDetailId, receivedQuantity) => {
    const detailKey = `detail_${uniqueDetailId}`;

    try {
      // Устанавливаем статус "сохранение"
      setDetailSavingStatus(prev => ({
        ...prev,
        [detailKey]: 'saving'
      }));

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trip-details/${uniqueDetailId}/mark-received`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ receivedQuantity })
      });

      if (!response.ok) {
        throw new Error('Ошибка сохранения отметки');
      }

      // Устанавливаем статус "сохранено"
      setDetailSavingStatus(prev => ({
        ...prev,
        [detailKey]: 'saved'
      }));

      // Через 2 секунды убираем индикатор
      setTimeout(() => {
        setDetailSavingStatus(prev => {
          const newStatus = { ...prev };
          delete newStatus[detailKey];
          return newStatus;
        });
      }, 2000);
    } catch (err) {
      console.error('Ошибка автосохранения детали:', err);
      setDetailSavingStatus(prev => ({
        ...prev,
        [detailKey]: 'error'
      }));

      // Через 3 секунды убираем индикатор ошибки
      setTimeout(() => {
        setDetailSavingStatus(prev => {
          const newStatus = { ...prev };
          delete newStatus[detailKey];
          return newStatus;
        });
      }, 3000);
    }
  };

  // Функция с debounce для автосохранения
  const debouncedSaveDetail = (uniqueDetailId, receivedQuantity) => {
    const detailKey = `detail_${uniqueDetailId}`;

    // Очищаем предыдущий таймер для этой детали
    if (saveTimersRef.current[detailKey]) {
      clearTimeout(saveTimersRef.current[detailKey]);
    }

    // Устанавливаем новый таймер
    saveTimersRef.current[detailKey] = setTimeout(() => {
      saveDetailReceived(uniqueDetailId, receivedQuantity);
    }, 500); // Задержка 500мс перед сохранением
  };

  // Автосохранение рейса (без алертов и закрытия модалки)
  const autoSaveTrip = async () => {
    // Только для редактирования существующего рейса
    if (!editingTrip.id) {
      return;
    }

    try {
      setDetailSavingStatus(prev => ({
        ...prev,
        'trip_autosave': 'saving'
      }));

      const token = localStorage.getItem('token');
      const selectedDetails = tripDetails.filter(d => d.isSelected);

      if (selectedDetails.length === 0) {
        setDetailSavingStatus(prev => ({
          ...prev,
          'trip_autosave': 'idle'
        }));
        return;
      }

      const uniqueOrders = new Set(selectedDetails.map(d => d.orderId));
      const tripData = {
        type: editingTrip.type,
        partner: tripPartner,
        status: editingTrip.status,
        notes: editingTrip.notes,
        details: selectedDetails.map(d => ({
          order_id: d.orderId,
          order_number: d.orderNumber,
          detail_id: d.detailId,
          detail_text: d.detailText,
          glass_type: d.glassType,
          quantity: d.quantity
        })),
        totalOrders: uniqueOrders.size,
        totalDetails: selectedDetails.reduce((sum, d) => sum + (d.quantity || 1), 0)
      };

      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${editingTrip.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tripData)
      });

      if (!response.ok) {
        throw new Error('Ошибка автосохранения рейса');
      }

      // Обновляем список рейсов в фоне
      await Promise.all([
        fetchTrips(),
        fetchDetailsInTrips()
      ]);

      setDetailSavingStatus(prev => ({
        ...prev,
        'trip_autosave': 'saved'
      }));

      // Сбрасываем индикатор "сохранено" через 2 секунды
      setTimeout(() => {
        setDetailSavingStatus(prev => ({
          ...prev,
          'trip_autosave': 'idle'
        }));
      }, 2000);

    } catch (error) {
      console.error('Ошибка автосохранения рейса:', error);
      setDetailSavingStatus(prev => ({
        ...prev,
        'trip_autosave': 'error'
      }));

      // Сбрасываем индикатор ошибки через 3 секунды
      setTimeout(() => {
        setDetailSavingStatus(prev => ({
          ...prev,
          'trip_autosave': 'idle'
        }));
      }, 3000);
    }
  };

  // Debounced версия автосохранения рейса
  const debouncedAutoSaveTrip = () => {
    const timerKey = 'trip_autosave_timer';

    // Очищаем предыдущий таймер
    if (saveTimersRef.current[timerKey]) {
      clearTimeout(saveTimersRef.current[timerKey]);
    }

    // Устанавливаем новый таймер
    saveTimersRef.current[timerKey] = setTimeout(() => {
      autoSaveTrip();
      delete saveTimersRef.current[timerKey];
    }, 800); // Задержка 800мс перед сохранением
  };

  // Функция просмотра рейса
  const handleViewTrip = async (trip) => {
    try {
      setViewingTrip(trip);
    setReceivedDetails({});                    // сбрасываем предыдущие отметки
    setReceivingDetailsSearch('');
    setReceivingThicknessFilter('all');
    setShowViewTripModal(true);
      // Для рейсов на этапе приёмки (received_from_partner) всегда обновляем данные из БД
      // чтобы получить актуальные received_quantity
      if (trip.status === 'received_from_partner') {
        setTripDetailsData(prev => {
          const newData = { ...prev };
          delete newData[trip.id]; // Очищаем кэш для этого рейса
          return newData;
        });
      }

      // Загружаем детали и получаем их напрямую из результата
      const details = await fetchTripDetails(trip.id);

      // Инициализируем детали на основе сохраненных данных из БД
      // По умолчанию все галочки СНЯТЫ (0), если нет сохранённого значения в БД
      const initialReceivedDetails = {};
      if (details && details.length > 0) {
        details.forEach(detail => {
          // Если есть received_quantity в БД - используем его
          // Иначе ставим 0 (по умолчанию галочка снята)
          if (detail.received_quantity !== null && detail.received_quantity !== undefined) {
            initialReceivedDetails[detail.id] = detail.received_quantity;
          } else {
            initialReceivedDetails[detail.id] = 0; // По умолчанию снято
          }
        });
      }
      setReceivedDetails(initialReceivedDetails);
      setReceivingDetailsSearch(''); // Сбрасываем поиск при открытии
      setReceivingThicknessFilter('all'); // Сбрасываем фильтр толщины

      setShowViewTripModal(true);
    } catch (err) {
      console.error("Ошибка открытия просмотра рейса:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Функция очистки завершенных рейсов
  const handleCleanupTrips = async () => {
    const completedCount = trips.filter(t => t.status === 'received').length;

    if (completedCount === 0) {
      alert('Нет завершенных рейсов для удаления');
      return;
    }

    if (!confirm(`Удалить ${completedCount} завершенных рейсов? Это действие нельзя отменить.`)) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/cleanup`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка очистки рейсов');
      }

      const data = await response.json();

      // Перезагружаем список рейсов и деталей в рейсах
      await Promise.all([
        fetchTrips(),
        fetchDetailsInTrips()
      ]);

      alert(data.message || `Удалено рейсов: ${data.deletedCount}`);
    } catch (err) {
      console.error("Ошибка очистки рейсов:", err);
      alert(`Ошибка при очистке рейсов: ${err.message}`);
    }
  };

  // Функция загрузки деталей рейса для редактирования
  const handleEditTrip = async (tripId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/zakalka-trips/${tripId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки деталей рейса');
      }

      const tripData = await response.json();

      // Преобразуем детали из формата БД в формат интерфейса
      const details = tripData.details.map((d, index) => ({
        orderId: d.order_id,
        orderNumber: d.order_number,
        detailId: d.detail_id,
        detailText: d.detail_text,
        glassType: d.glass_type,
        thickness: d.thickness,
        color: d.color,
        height: d.height,
        width: d.width,
        area: d.area,
        quantity: d.quantity,
        maxQuantity: d.quantity, // Для редактирования используем текущее количество как максимум
        isSelected: true, // При редактировании все детали выбраны по умолчанию
        originalIndex: index
      }));

      setEditingTrip({
        id: tripData.id,
        tripNumber: tripData.tripNumber,
        type: tripData.type,
        status: tripData.status,
        notes: tripData.notes || '',
        partner: tripData.partner,
        createdDate: tripData.createdDate,
        shippedDate: tripData.shippedDate,
        deliveredToPartnerDate: tripData.deliveredToPartnerDate,
        receivedFromPartnerDate: tripData.receivedFromPartnerDate,
        receivedFromZakalkaDate: tripData.receivedFromZakalkaDate,
        details: details
      });
      setTripPartner(tripData.partner || 'Казстековид');
      setTripDetails(details);
      setShowTripModal(true);
    } catch (err) {
      console.error("Ошибка загрузки деталей рейса:", err);
      alert(`Ошибка при загрузке деталей рейса: ${err.message}`);
    }
  };

  // Открыть модальное окно редактирования деталей рейса
  const handleEditTripForEdit = async (trip) => {
    // Сбрасываем состояния загрузки
    setLoadingTripDetailsInModal(false);
    setLoadingAvailableDetailsInModal(false);

    // Сразу открываем модальное окно с базовой информацией
    setEditingTrip({
      id: trip.id,
      type: trip.type,
      status: trip.status,
      notes: trip.notes || '',
      partner: trip.partner || 'Казстековид',
      tripNumber: trip.tripNumber,
      details: []
    });
    setTripPartner(trip.partner || 'Казстековид');
    setTripDetails([]);
    setAvailableDetails([]);
    setEditModalTab('details'); // Сбрасываем на первую вкладку
    setShowEditModal(true);

    // Загружаем детали рейса асинхронно
    setLoadingTripDetailsInModal(true);
    try {
      const token = localStorage.getItem('token');
      const tripResponse = await fetch(`${API_BASE_URL}/api/zakalka-trips/${trip.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!tripResponse.ok) {
        throw new Error('Ошибка загрузки деталей рейса');
      }

      const tripData = await tripResponse.json();

      // Преобразуем детали из формата БД в формат интерфейса
      const details = tripData.details.map(d => ({
        orderId: d.order_id,
        orderNumber: d.order_number,
        detailId: d.detail_id,
        detailText: d.detail_text,
        glassType: d.glass_type,
        quantity: d.quantity,
        maxQuantity: d.quantity,
        isSelected: true,
        inTrip: true
      }));

      setEditingTrip(prev => ({
        ...prev,
        tripNumber: tripData.tripNumber,
        details: details
      }));
      setTripDetails(details);
      setLoadingTripDetailsInModal(false);

      // Загружаем доступные заказы для добавления деталей
      loadAvailableDetailsForEdit(details, trip.id);
    } catch (err) {
      console.error("Ошибка загрузки деталей рейса:", err);
      setLoadingTripDetailsInModal(false);
      alert(`Ошибка при загрузке деталей рейса: ${err.message}`);
    }
  };

  // Загрузка доступных деталей для добавления в рейс
  const loadAvailableDetailsForEdit = async (tripDetails, tripId) => {
    setLoadingAvailableDetailsInModal(true);
    try {
      const token = localStorage.getItem('token');

      // Загружаем информацию о деталях, которые уже в других рейсах
      let detailsInOtherTrips = new Set();
      try {
        const tripsDetailsResponse = await fetch(`${API_BASE_URL}/api/zakalka-trips-details-in-use`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (tripsDetailsResponse.ok) {
          const tripsDetailsData = await tripsDetailsResponse.json();
          if (tripsDetailsData.success && tripsDetailsData.details) {
            detailsInOtherTrips = new Set(
              tripsDetailsData.details
                .filter(d => d.tripId !== tripId)
                .map(d => `${d.orderId}_${d.detailId}`)
            );
          }
        }
      } catch (err) {
        console.warn("Ошибка загрузки деталей в рейсах:", err);
      }

      // Загружаем доступные заказы через BitrixAPI
      const orders = await BitrixAPI.getActiveOrderszakalka();
      const detailsInCurrentTrip = new Set(tripDetails.map(d => `${d.orderId}_${d.detailId}`));

      // Формируем список доступных деталей
      const available = [];
      for (const order of orders || []) {
        try {
          const detailsResponse = await axios.get(`${API_URL}/api/glass-details-fixed/${order.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            },
            timeout: 30000
          });

          if (detailsResponse.data.success) {
            const glassDetails = detailsResponse.data.glassDetails || [];
            glassDetails.forEach(detail => {
              const detailKey = `${order.id}_${detail.id}`;
              if (!detailsInCurrentTrip.has(detailKey) && !detailsInOtherTrips.has(detailKey)) {
                available.push({
                  orderId: order.id,
                  orderNumber: order.orderNumber || order.id,
                  detailId: detail.id,
                  detailText: detail.originalText,
                  glassType: detail.glassType,
                  thickness: detail.thickness,
                  color: detail.color,
                  quantity: 0,
                  maxQuantity: detail.quantity || 1,
                  isSelected: false,
                  inTrip: false
                });
              }
            });
          }
        } catch (detailErr) {
          console.error(`Ошибка загрузки деталей заказа ${order.id}:`, detailErr);
        }
      }

      setAvailableDetails(available);
      setLoadingAvailableDetailsInModal(false);
    } catch (err) {
      console.error("Ошибка загрузки доступных деталей:", err);
      setLoadingAvailableDetailsInModal(false);
    }
  };

  // Обработчики для модального окна редактирования
  const handleTripDetailToggle = (detailIndex) => {
    const newDetails = [...tripDetails];
    newDetails[detailIndex] = { ...newDetails[detailIndex], isSelected: !newDetails[detailIndex].isSelected };
    setTripDetails(newDetails);

    // Автосохранение при редактировании существующего рейса
    if (editingTrip.id) {
      debouncedAutoSaveTrip();
    }
  };

  const handleTripDetailQuantityChange = (detailIndex, newQuantity) => {
    const newDetails = [...tripDetails];
    const detail = newDetails[detailIndex];
    if (newQuantity >= 1 && newQuantity <= detail.maxQuantity) {
      newDetails[detailIndex] = { ...detail, quantity: newQuantity };
      setTripDetails(newDetails);
    }
  };

  const handleAvailableDetailToggle = (detailIndex) => {
    const newDetails = [...availableDetails];
    const detail = newDetails[detailIndex];
    newDetails[detailIndex] = { ...detail, isSelected: !detail.isSelected };
    if (!detail.isSelected && detail.quantity === 0) {
      newDetails[detailIndex].quantity = detail.maxQuantity;
    }
    setAvailableDetails(newDetails);
  };

  const handleAvailableDetailQuantityChange = (detailIndex, newQuantity) => {
    const newDetails = [...availableDetails];
    const detail = newDetails[detailIndex];
    if (newQuantity >= 0 && newQuantity <= detail.maxQuantity) {
      newDetails[detailIndex] = { ...detail, quantity: newQuantity };
      setAvailableDetails(newDetails);
    }
  };

  const handleAddToTrip = () => {
    const selectedAvailable = availableDetails.filter(d => d.isSelected && d.quantity > 0);
    if (selectedAvailable.length === 0) {
      alert('Выберите детали для добавления в рейс');
      return;
    }

    const detailsToAdd = selectedAvailable.map(d => ({
      ...d,
      inTrip: true,
      isSelected: true
    }));

    const updatedTripDetails = [...tripDetails, ...detailsToAdd];
    setTripDetails(updatedTripDetails);

    const remainingAvailable = availableDetails.filter(d => !(d.isSelected && d.quantity > 0));
    setAvailableDetails(remainingAvailable);
  };

  // Отображение доступных рейсов для приема
  // Функция для отображения рейсов отгрузки
  const renderShippingTrips = () => {
    // Фильтруем рейсы отгрузки только со статусом "saved"
    const shippingTrips = trips.filter(trip => trip.type === 'shipping' && trip.status === 'saved');

    return (
      <div className="space-y-2">
        {shippingTrips.length === 0 ? (
          <div className="text-center py-4 bg-white rounded-lg shadow">
            <p className="text-gray-500 text-sm">Нет рейсов отгрузки</p>
          </div>
        ) : (
          shippingTrips.map(trip => (
            <div key={trip.id} className="bg-white rounded-lg shadow-sm border border-gray-100 p-2">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3 flex-1">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-semibold text-gray-800">#{trip.tripNumber}</span>
                      <span className="text-xs text-purple-600 font-medium">{trip.partner}</span>
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${
                        trip.status === 'saved' ? 'bg-gray-100 text-gray-600' :
                        trip.status === 'shipped' ? 'bg-blue-100 text-blue-700' :
                        trip.status === 'delivered_to_partner' ? 'bg-yellow-100 text-yellow-700' :
                        trip.status === 'received_from_partner' ? 'bg-green-100 text-green-700' :
                        'bg-gray-100 text-gray-600'
                      }`}>
                        {trip.status === 'saved' ? '💾' :
                         trip.status === 'shipped' ? '🚚' :
                         trip.status === 'delivered_to_partner' ? '🏭' :
                         trip.status === 'received_from_partner' ? '📦' :
                         trip.status === 'received' ? '✅' : ''}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 mt-1 text-[10px] text-gray-500">
                      <span>{new Date(trip.createdDate).toLocaleDateString('ru-RU')}</span>
                      <span>Заказов: <b>{trip.totalOrders || 0}</b></span>
                      <span>Деталей: <b>{trip.totalDetails || 0}</b></span>
                    </div>
                  </div>
                  {/* Бирки по толщине */}
                  {tripDetailsData[trip.id] && tripDetailsData[trip.id].length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {(() => {
                        const thicknessStats = {};
                        tripDetailsData[trip.id].forEach(detail => {
                          let thickness = detail.thickness;
                          if (!thickness && detail.glass_type) {
                            const match = detail.glass_type.match(/(\d+)\s*мм/i);
                            if (match) thickness = match[1] + 'мм';
                          }
                          if (!thickness) thickness = '?';
                          if (!thicknessStats[thickness]) thicknessStats[thickness] = 0;
                          thicknessStats[thickness] += detail.quantity || 1;
                        });
                        return Object.entries(thicknessStats)
                          .filter(([t]) => t !== '?')
                          .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
                          .map(([thickness, count]) => (
                            <span key={thickness} className="px-1.5 py-0.5 bg-blue-50 text-blue-700 rounded text-[10px] font-medium">
                              {thickness}: {count}
                            </span>
                          ));
                      })()}
                    </div>
                  )}
                </div>
                <button
                  onClick={() => handleEditTrip(trip.id)}
                  className="px-3 py-1.5 bg-blue-500 text-white rounded text-xs hover:bg-blue-600 transition-colors ml-2"
                >
                  Открыть
                </button>
              </div>
              {trip.notes && (
                <p className="text-[10px] text-gray-500 mt-1 truncate">
                  📝 {trip.notes}
                </p>
              )}
            </div>
          ))
        )}
      </div>
    );
  };

  const renderReceivingTrips = () => {
    // Отладка: показываем все рейсы
    console.log('Все рейсы:', trips);
    console.log('Рейсы с фильтрацией received_from_partner:', trips.filter(trip => trip.status === 'received_from_partner'));

    // Фильтруем только рейсы готовые для приема (забраны у партнера)
    const receivingTrips = trips.filter(trip => trip.status === 'received_from_partner');

    const statusConfig = {
      received_from_partner: { icon: '📦', label: 'Забран у партнера', color: 'bg-orange-100 text-orange-800' }
    };

    return (
      <div>
        {receivingTrips.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <p className="text-lg">📦</p>
            <p className="mt-2">Нет рейсов готовых для приема</p>
            <p className="text-sm mt-1">Рейсы появятся здесь после того как водитель заберет их у партнера</p>
          </div>
        ) : (
          <div className="space-y-3">
            {receivingTrips.map(trip => {
              const status = statusConfig[trip.status];

              return (
                <div
                  key={trip.id}
                  className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow"
                >
                  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="text-sm sm:text-base font-semibold text-gray-800">
                          Рейс №{trip.tripNumber}
                        </h3>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${status.color}`}>
                          {status.icon} {status.label}
                        </span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          trip.type === 'shipping' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'
                        }`}>
                          {trip.type === 'shipping' ? 'Отгрузка' : 'Прием'}
                        </span>
                      </div>
                      <div className="text-xs text-gray-600 space-y-1">
                        <p>Партнер: <span className="font-medium text-purple-700">{trip.partner}</span></p>
                        <p>Создан: {new Date(trip.createdDate).toLocaleString('ru-RU')}</p>
                        {trip.shippedDate && <p>Принят водителем: {new Date(trip.shippedDate).toLocaleString('ru-RU')}</p>}
                        {trip.deliveredToPartnerDate && <p>Сдан партнеру: {new Date(trip.deliveredToPartnerDate).toLocaleString('ru-RU')}</p>}
                        {trip.receivedFromPartnerDate && <p>Забран у партнера: {new Date(trip.receivedFromPartnerDate).toLocaleString('ru-RU')}</p>}
                        <p>Заказов: {trip.totalOrders} | Деталей: {trip.totalDetails}</p>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-1">
                      <button
                        onClick={() => handleViewTrip(trip)}
                        className="px-3 py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                      >
                        👁️ Просмотр
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  if (loading) return <div className="p-4">Загрузка заказов...</div>;

  // Подсчет заказов с учетом фильтрации
  const getOrdersCounts = (orders) => {
    const total = orders.length;
    const filtered = filterOrders(orders).length;
    const available = filtered;
    const inBatches = 0; // Не учитываем рейсы
    
    return { total, available, inBatches, filtered };
  };

  const shippingCounts = getOrdersCounts(activeOrders);
  // Для вкладки приема показываем количество доступных рейсов
  const receivingTripsCount = trips.filter(t => t.status === 'received_from_partner').length;
  const receivingCounts = { filtered: receivingTripsCount, total: receivingTripsCount };

  // Фильтруем детали по поисковому запросу
  const filteredTripDetails = tripDetails.filter(detail => {
    if (!tripDetailsSearch) return true;
    const searchLower = tripDetailsSearch.toLowerCase();
    return (
      detail.orderNumber.toString().toLowerCase().includes(searchLower) ||
      detail.detailText.toLowerCase().includes(searchLower)
    );
  });

  // Группируем отфильтрованные детали по заказам
  const groupedTripDetails = {};
  filteredTripDetails.forEach((detail, index) => {
    // Находим оригинальный индекс в tripDetails
    const originalIndex = tripDetails.findIndex(d =>
      d.orderId === detail.orderId && d.detailId === detail.detailId
    );

    if (!groupedTripDetails[detail.orderId]) {
      groupedTripDetails[detail.orderId] = [];
    }
    groupedTripDetails[detail.orderId].push({ ...detail, originalIndex });
  });

  // Фильтрация и группировка для модального окна редактирования
  const filteredTripDetailsForEditModal = tripDetails.filter(detail => {
    // Фильтр по толщине
    if (tripDetailsThicknessFilter !== 'all') {
      let thickness = null;
      if (detail.thickness) {
        thickness = detail.thickness;
      } else if (detail.glassType) {
        const match = detail.glassType.match(/(\d+)\s*мм/i);
        if (match) thickness = match[1] + 'мм';
      }
      if (thickness !== tripDetailsThicknessFilter) return false;
    }

    // Фильтр по поиску
    if (!tripDetailsSearch) return true;
    const searchLower = tripDetailsSearch.toLowerCase();
    return (
      detail.orderNumber.toString().toLowerCase().includes(searchLower) ||
      detail.detailText.toLowerCase().includes(searchLower)
    );
  });

  const groupedTripDetailsForEditModal = {};
  filteredTripDetailsForEditModal.forEach((detail, index) => {
    const originalIndex = tripDetails.findIndex(d =>
      d.orderId === detail.orderId && d.detailId === detail.detailId
    );

    if (!groupedTripDetailsForEditModal[detail.orderId]) {
      groupedTripDetailsForEditModal[detail.orderId] = [];
    }
    groupedTripDetailsForEditModal[detail.orderId].push({ ...detail, originalIndex });
  });

  const filteredAvailableDetailsForEditModal = availableDetails.filter(detail => {
    if (!availableDetailsSearch) return true;
    const searchLower = availableDetailsSearch.toLowerCase();
    return (
      detail.orderNumber.toString().toLowerCase().includes(searchLower) ||
      detail.detailText.toLowerCase().includes(searchLower)
    );
  });

  const groupedAvailableDetailsForEditModal = {};
  filteredAvailableDetailsForEditModal.forEach((detail, index) => {
    const originalIndex = availableDetails.findIndex(d =>
      d.orderId === detail.orderId && d.detailId === detail.detailId
    );

    if (!groupedAvailableDetailsForEditModal[detail.orderId]) {
      groupedAvailableDetailsForEditModal[detail.orderId] = [];
    }
    groupedAvailableDetailsForEditModal[detail.orderId].push({ ...detail, originalIndex });
  });

  return (
    <div className="page-container">
      {/* Прокручиваемая область */}
      <div className="scrollable-area">
        {/* Вкладки */}
        <div className="container mx-auto px-4 pt-4">

          {/* Tabs */}
          <div className="mb-6">
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-2 sm:space-x-8 overflow-x-auto" aria-label="Tabs">
                <button
                  onClick={() => setActiveTab("shipping")}
                  className={`flex-shrink-0 py-2 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm ${
                    activeTab === "shipping"
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  <span className="hidden sm:inline">Отгрузка на закалку</span>
                  <span className="sm:hidden">Отгрузка</span>
                  <span className="ml-1 sm:ml-2 px-1.5 sm:px-2 py-0.5 sm:py-1 text-xs bg-blue-100 text-blue-800 rounded-full">
                    {shippingCounts.filtered}{shippingCounts.total !== shippingCounts.filtered ? `/${shippingCounts.total}` : ''}
                  </span>
                </button>
                <button
                  onClick={() => setActiveTab("receiving")}
                  className={`flex-shrink-0 py-2 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm ${
                    activeTab === "receiving"
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  <span className="hidden sm:inline">Прием с закалки</span>
                  <span className="sm:hidden">Прием</span>
                  <span className="ml-1 sm:ml-2 px-1.5 sm:px-2 py-0.5 sm:py-1 text-xs bg-blue-100 text-blue-800 rounded-full">
                    {receivingCounts.filtered}{receivingCounts.total !== receivingCounts.filtered ? `/${receivingCounts.total}` : ''}
                  </span>
                </button>
              </nav>
            </div>
          </div>

          {/* Уведомление о новых заказах */}
          {newOrdersNotification && (
            <div className="bg-green-50 border-2 border-green-400 text-green-800 px-4 py-3 rounded-lg mb-4 shadow-lg animate-pulse">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <strong className="text-lg">Поступило {newOrdersNotification.count} новых заказов закалки!</strong>
                    <div className="text-sm text-green-700 mt-1">
                      Заказы: {newOrdersNotification.orderNumbers.join(', ')}
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => setNewOrdersNotification(null)}
                  className="text-green-600 hover:text-green-800 transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Кнопки управления */}
      <div className="container mx-auto px-4 mb-4">
        {activeTab === "shipping" && (
          <div className="flex flex-wrap gap-1">
            <LoadingButton
              isLoading={creatingTrip}
              onClick={() => handleCreateTripFromSelected('shipping')}
              label="📦 Создать рейс"
              color="blue"
            />
          </div>
        )}
        
      </div>

      
      
      {/* Отображение ошибок */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          <strong>Ошибка:</strong> {error}
          <button 
            onClick={() => setError(null)}
            className="ml-2 text-red-500 hover:text-red-700"
          >
            ✕
          </button>
        </div>
      )}

      <div className="page-content">
        <div className="container mx-auto p-4">
          {loading && (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="mt-2 text-gray-600">Загрузка заказов...</p>
            </div>
          )}

          {/* Содержимое вкладок */}
          {activeTab === "shipping" && renderShippingTrips()}
          {activeTab === "receiving" && renderReceivingTrips()}
        </div>
      </div>

      {/* Модальное окно создания/редактирования рейса */}
      {showTripModal && editingTrip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] overflow-y-auto">
          <div className="min-h-screen flex items-start justify-center p-4 pt-8">
            <div className="bg-white rounded-lg max-w-5xl w-full max-h-[calc(100vh-4rem)] overflow-hidden flex flex-col shadow-2xl">
            {/* Заголовок */}
            <div className="flex items-center justify-between px-4 py-2 border-b">
              <h2 className="text-lg font-semibold">
                {editingTrip?.id ? `Рейс #${editingTrip.tripNumber || editingTrip.id}` : 'Создание нового рейса'}
              </h2>
              <button
                onClick={() => {
                  setShowTripModal(false);
                  setEditingTrip(null);
                }}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✕
              </button>
            </div>

            {/* Содержимое */}
            <div className="flex-1 overflow-hidden p-3 flex flex-col">
              {tripDetails.length > 0 ? (
                <>
                  {/* Информация о рейсе и статистика */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-3 flex-shrink-0">
                    <h3 className="font-semibold text-sm mb-2">Информация о рейсе</h3>
                    <div className="grid grid-cols-3 gap-x-4 gap-y-2 text-xs mb-3">
                      <div>
                        <span className="text-gray-600">Статус:</span>
                        <div className="mt-1">
                          {(() => {
                            const statusConfig = {
                              saved: { icon: '💾', label: 'Сохранен', color: 'bg-gray-100 text-gray-800' },
                              shipped: { icon: '🚚', label: 'Принят водителем', color: 'bg-blue-100 text-blue-800' },
                              delivered_to_partner: { icon: '🏭', label: 'У партнера', color: 'bg-yellow-100 text-yellow-800' },
                              received_from_partner: { icon: '📦', label: 'Забран у партнера', color: 'bg-orange-100 text-orange-800' },
                              received: { icon: '✅', label: 'Принят с закалки', color: 'bg-green-100 text-green-800' }
                            };
                            const status = statusConfig[editingTrip.status] || statusConfig.saved;
                            return (
                              <span className={`inline-block px-2 py-1 rounded-full text-xs ${status.color}`}>
                                {status.icon} {status.label}
                              </span>
                            );
                          })()}
                        </div>
                      </div>
                      <div>
                        <span className="text-gray-600">Тип:</span>
                        <p className="font-medium">{editingTrip.type === 'shipping' ? 'Отгрузка' : 'Прием'}</p>
                      </div>
                      <div>
                        <span className="text-gray-600">Партнер:</span>
                        <p className="font-medium text-purple-700">{editingTrip.partner || tripPartner}</p>
                      </div>
                      {editingTrip.createdDate && (
                        <div>
                          <span className="text-gray-600">Создан:</span>
                          <p className="font-medium">{new Date(editingTrip.createdDate).toLocaleString('ru-RU')}</p>
                        </div>
                      )}
                      {editingTrip.shippedDate && (
                        <div>
                          <span className="text-gray-600">Принят водителем:</span>
                          <p className="font-medium">{new Date(editingTrip.shippedDate).toLocaleString('ru-RU')}</p>
                        </div>
                      )}
                      {editingTrip.deliveredToPartnerDate && (
                        <div>
                          <span className="text-gray-600">Сдан партнеру:</span>
                          <p className="font-medium">{new Date(editingTrip.deliveredToPartnerDate).toLocaleString('ru-RU')}</p>
                        </div>
                      )}
                      {editingTrip.receivedFromPartnerDate && (
                        <div>
                          <span className="text-gray-600">Забран у партнера:</span>
                          <p className="font-medium">{new Date(editingTrip.receivedFromPartnerDate).toLocaleString('ru-RU')}</p>
                        </div>
                      )}
                      {editingTrip.receivedFromZakalkaDate && (
                        <div>
                          <span className="text-gray-600">Принят с закалки:</span>
                          <p className="font-medium">{new Date(editingTrip.receivedFromZakalkaDate).toLocaleString('ru-RU')}</p>
                        </div>
                      )}
                      <div>
                        <span className="text-gray-600">Всего заказов:</span>
                        <p className="font-medium">{new Set(tripDetails.map(d => d.orderId)).size}</p>
                      </div>
                      <div>
                        <span className="text-gray-600">Всего деталей:</span>
                        <p className="font-medium">{tripDetails.reduce((sum, d) => sum + (d.quantity || 1), 0)}</p>
                      </div>
                    </div>

                    {/* Статистика */}
                    {(() => {
                      const thicknessStats = {};
                      let totalQuantity = 0;
                      let totalArea = 0;

                      tripDetails.forEach(detail => {
                        const detailText = detail.detailText || '';
                        const glassType = detail.glassType || '';
                        const quantity = detail.quantity || 1;

                        let thickness = 'Неизвестная толщина';
                        // Используем поле thickness напрямую, если оно есть
                        if (detail.thickness) {
                          thickness = detail.thickness;
                        } else if (glassType) {
                          const thicknessMatch = glassType.match(/(\d+)\s*мм/);
                          if (thicknessMatch) {
                            thickness = `${thicknessMatch[1]}мм`;
                          }
                        } else if (detailText) {
                          const thicknessMatch = detailText.match(/(\d+)\s*мм/);
                          if (thicknessMatch) {
                            thickness = `${thicknessMatch[1]}мм`;
                          }
                        }

                        let area = 0;
                        if (detail.area) {
                          area = detail.area * quantity;
                        } else if (detailText) {
                          const sizeMatch = detailText.match(/(\d+)\s*[xх×*]\s*(\d+)/i);
                          if (sizeMatch) {
                            const height = parseInt(sizeMatch[1]);
                            const width = parseInt(sizeMatch[2]);
                            area = (height * width * quantity) / 1000000;
                          }
                        }

                        if (!thicknessStats[thickness]) {
                          thicknessStats[thickness] = { quantity: 0, area: 0 };
                        }

                        thicknessStats[thickness].quantity += quantity;
                        thicknessStats[thickness].area += area;
                        totalQuantity += quantity;
                        totalArea += area;
                      });

                      return (
                        <>
                          <div className="border-t border-blue-300 pt-2 mb-2">
                            <div className="grid grid-cols-4 gap-2">
                              <div>
                                <p className="text-xs text-gray-600">Общее кол-во:</p>
                                <p className="text-base font-bold text-blue-900">{totalQuantity} шт</p>
                              </div>
                              <div>
                                <p className="text-xs text-gray-600">Общая площадь:</p>
                                <p className="text-base font-bold text-blue-900">{totalArea.toFixed(2)} м²</p>
                              </div>
                              <div className="col-span-2">
                                <p className="text-xs font-semibold text-gray-700 mb-1">По толщине:</p>
                                <div className="flex flex-wrap gap-x-3 gap-y-0.5">
                                  {Object.entries(thicknessStats)
                                    .filter(([thickness]) => thickness !== 'Неизвестная толщина')
                                    .map(([thickness, stats]) => (
                                      <span key={thickness} className="text-xs text-gray-700">
                                        <span className="font-medium">{thickness}:</span> {stats.quantity}шт, {stats.area.toFixed(2)}м²
                                      </span>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>

                  {/* Список деталей */}
<div className="flex-1 flex flex-col min-h-0 border border-gray-200 rounded-lg overflow-hidden bg-white">
  <div className="flex-shrink-0 p-1.5 border-b border-gray-200 bg-gray-50">
    <h3 className="font-semibold text-[10px] mb-1 uppercase text-gray-400">Детали рейса</h3>
    <input
      type="text"
      placeholder="Поиск..."
      value={tripDetailsSearch}
      onChange={(e) => setTripDetailsSearch(e.target.value)}
      className="w-full px-2 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    />
  </div>

  <div className="flex-1 overflow-y-auto">
    {(() => {
      const searchLower = tripDetailsSearch.toLowerCase();
      const filteredDetails = tripDetails.filter(detail => {
        const detailText = (detail.detailText || '').toLowerCase();
        const glassType = (detail.glassType || '').toLowerCase();
        const orderNumber = (detail.orderNumber || '').toLowerCase();
        return orderNumber.includes(searchLower) ||
               detailText.includes(searchLower) ||
               glassType.includes(searchLower);
      });

      return (
        <table className="w-full text-[11px]"> {/* Уменьшен основной шрифт таблицы */}
          <thead className="bg-gray-100 border-b border-gray-200 sticky top-0">
            <tr>
              <th className="px-2 py-1 text-left font-semibold text-gray-500">Заказ</th>
              <th className="px-2 py-1 text-left font-semibold text-gray-500">Размеры</th>
              <th className="px-2 py-1 text-left font-semibold text-gray-500">Тип стекла</th>
              <th className="px-2 py-1 text-center font-semibold text-gray-500">Кол-во</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredDetails.length > 0 ? (
              filteredDetails.map((detail, idx) => {
                const detailText = detail.detailText;
                const glassType = detail.glassType;
                const quantity = detail.quantity;
                const orderNumber = detail.orderNumber;

                return (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-2 py-0.5 font-medium text-gray-500">{orderNumber}</td>
                    <td className="px-2 py-0.5 text-gray-500">{detailText}</td>
                    <td className="px-2 py-0.5">
                      {(detail.color || detail.thickness || glassType) ? (
                        <span className="inline-block px-1 py-0 bg-purple-100 text-purple-500 rounded text-[10px]">
                          {detail.color && <span className="font-medium leading-tight">{detail.color}</span>}
                          {detail.color && detail.thickness && ' '}
                          {detail.thickness && <span>{detail.thickness}</span>}
                          {!detail.color && !detail.thickness && glassType && <span>{glassType}</span>}
                        </span>
                      ) : (
                        <span className="text-gray-400 text-[10px]">—</span>
                      )}
                    </td>
                    <td className="px-2 py-0.5 text-center">
                      <span className="inline-block px-1.5 py-0 bg-blue-100 text-blue-800 rounded text-[10px] font-medium">
                        {quantity} шт
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="4" className="px-3 py-4 text-center text-gray-500 text-xs">
                  Детали не найдены
                </td>
              </tr>
                              )}
                            </tbody>
                          </table>
                        );
                      })()}
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center text-gray-500">
                    Нет деталей
                  </div>
                </div>
              )}
            </div>

            {/* Футер с кнопками */}
            <div className="border-t px-4 py-2 bg-gray-50">
              <div className="flex flex-wrap gap-2 items-center">
                

                {/* Кнопка для статуса "shipped" */}
                {editingTrip?.status === 'shipped' && editingTrip?.id && (
                  <button
                    onClick={async () => {
                      await handleDeliverToPartner(editingTrip.id);
                      setShowTripModal(false);
                      setEditingTrip(null);
                      await fetchTrips();
                    }}
                    className="px-3 py-2 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors"
                  >
                    🏭 Сдать партнеру
                  </button>
                )}

                {/* Кнопка для статуса "delivered_to_partner" */}
                {editingTrip?.status === 'delivered_to_partner' && editingTrip?.id && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromPartner(editingTrip.id);
                      setShowTripModal(false);
                      setEditingTrip(null);
                      await fetchTrips();
                    }}
                    className="px-3 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors"
                  >
                    📦 Забрать у партнера
                  </button>
                )}

                {/* Кнопка для статуса "received_from_partner" */}
                {editingTrip?.status === 'received_from_partner' && editingTrip?.id && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromZakalka(editingTrip.id);
                      setShowTripModal(false);
                      setEditingTrip(null);
                      await fetchTrips();
                    }}
                    className="px-3 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                  >
                    ✅ Принять с закалки
                  </button>
                )}

                {/* Кнопка генерации партнерского PDF */}
                <button
                  onClick={handleGenerateTripPartnerPDF}
                  disabled={tripDetails.length === 0 || generatingPartnerPDF}
                  className="px-3 py-2 text-sm bg-purple-500 text-white rounded hover:bg-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Сгенерировать отчет партнера"
                >
                  {generatingPartnerPDF ? '⏳ Генерация...' : '📄 Отчет партнера'}
                </button>

                {/* Кнопка редактировать (только для существующих рейсов) */}
                {editingTrip?.id && (
                  <button
                    onClick={() => {
                      setShowTripModal(false);
                      handleEditTripForEdit(editingTrip);
                    }}
                    className="px-3 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                  >
                    ✏️ Редактировать
                  </button>
                )}

                {/* Кнопка удалить (только для существующих рейсов) */}
                {editingTrip?.id && (
                  <button
                    onClick={async () => {
                      if (window.confirm(`Вы уверены, что хотите удалить рейс #${editingTrip.tripNumber}?`)) {
                        await handleDeleteTrip(editingTrip.id);
                        setShowTripModal(false);
                        setEditingTrip(null);
                        await fetchTrips();
                      }
                    }}
                    className="px-3 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                  >
                    🗑️ Удалить
                  </button>
                )}

                {/* Кнопка закрыть */}
                <button
                  onClick={() => {
                    setShowTripModal(false);
                    setEditingTrip(null);
                  }}
                  className="ml-auto px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
                >
                  Закрыть
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
        
      )}

      {/* Модальное окно просмотра рейса */}
      {showViewTripModal && viewingTrip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] overflow-y-auto">
          <div className="min-h-screen flex items-start justify-center p-4 pt-8">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[calc(100vh-4rem)] overflow-hidden flex flex-col shadow-2xl">
            {/* Заголовок */}
            <div className="flex items-center justify-between p-4 border-b bg-gray-50">
              <h2 className="text-lg font-semibold">
                Рейс №{viewingTrip.tripNumber}
              </h2>
              <button
                onClick={() => {
                  setShowViewTripModal(false);
                  setViewingTrip(null);
                  setReceivingDetailsSearch('');
                }}
                className="text-gray-500 hover:text-gray-700 text-2xl w-8 h-8"
              >
                ✕
              </button>
            </div>

            {/* Содержимое */}
            <div className="flex-1 overflow-y-auto p-2">
              {/* Информация о рейсе — компактный блок */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 mb-3">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
                  {(() => {
                    const statusConfig = {
                      saved: { icon: '💾', label: 'Сохранен', color: 'bg-gray-100 text-gray-800' },
                      shipped: { icon: '🚚', label: 'Принят водителем', color: 'bg-blue-100 text-blue-800' },
                      delivered_to_partner: { icon: '🏭', label: 'У партнера', color: 'bg-yellow-100 text-yellow-800' },
                      received_from_partner: { icon: '📦', label: 'Забран у партнера', color: 'bg-orange-100 text-orange-800' },
                      received: { icon: '✅', label: 'Принят с закалки', color: 'bg-green-100 text-green-800' }
                    };
                    const status = statusConfig[viewingTrip.status] || statusConfig.saved;
                    return (
                      <span className={`px-2 py-0.5 rounded-full ${status.color}`}>
                        {status.icon} {status.label}
                      </span>
                    );
                  })()}
                  <span className="text-gray-500">{viewingTrip.type === 'shipping' ? 'Отгрузка' : 'Прием'}</span>
                  <span className="text-purple-700 font-medium">{viewingTrip.partner || 'Не указан'}</span>
                  <span className="text-gray-500">Заказов: <span className="font-medium text-gray-800">{viewingTrip.totalOrders}</span></span>
                  <span className="text-gray-500">Деталей: <span className="font-medium text-gray-800">{viewingTrip.totalDetails}</span></span>
                </div>
              </div>

              {/* Детали рейса */}
              <div>
                {/* Фильтр по толщине и кнопки выбора */}
                {viewingTrip.status === 'received_from_partner' && (
                  <div className="mb-2">
                    {(() => {
                      const allDetails = tripDetailsData[viewingTrip.id] || [];
                      // Собираем уникальные толщины
                      const thicknessMap = {};
                      allDetails.forEach(d => {
                        let t = d.thickness || null;
                        if (!t && d.glass_type) {
                          const match = d.glass_type.match(/(\d+)\s*мм/i);
                          if (match) t = match[1] + 'мм';
                        }
                        const key = t || 'Без толщины';
                        if (!thicknessMap[key]) thicknessMap[key] = { total: 0, checked: 0 };
                        thicknessMap[key].total += d.quantity || 1;
                        const recQty = receivedDetails[d.id] ?? 0;
                        thicknessMap[key].checked += recQty;
                      });
                      const totalChecked = allDetails.reduce((sum, d) => sum + (receivedDetails[d.id] ?? 0), 0);
                      const totalQty = allDetails.reduce((sum, d) => sum + (d.quantity || 1), 0);
                      const thicknesses = Object.keys(thicknessMap).filter(k => k !== 'Без толщины').sort();
                      if (thicknessMap['Без толщины']) thicknesses.push('Без толщины');

                      return (
                        <div className="flex flex-wrap items-center gap-1">
                          <button
                            onClick={() => setReceivingThicknessFilter('all')}
                            className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
                              receivingThicknessFilter === 'all'
                                ? 'bg-blue-500 text-white'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            }`}
                          >
                            Все {totalChecked}/{allDetails.length}
                          </button>
                          {thicknesses.map(t => (
                            <button
                              key={t}
                              onClick={() => setReceivingThicknessFilter(t)}
                              className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
                                receivingThicknessFilter === t
                                  ? 'bg-blue-500 text-white'
                                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                              }`}
                            >
                              {t} {thicknessMap[t].checked}/{thicknessMap[t].total}
                            </button>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                )}

                {/* Поиск по деталям */}
                <div className="mb-3">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Поиск по номеру заказа или размеру детали..."
                      value={receivingDetailsSearch}
                      onChange={(e) => setReceivingDetailsSearch(e.target.value)}
                      className="w-full px-3 py-2 pl-9 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    {receivingDetailsSearch && (
                      <button
                        onClick={() => setReceivingDetailsSearch('')}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>

                {loadingTripDetails.has(viewingTrip.id) ? (
                  <div className="text-center py-8">
                    <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
                    <p className="mt-2 text-gray-600 text-sm">Загрузка деталей...</p>
                  </div>
                ) : tripDetailsData[viewingTrip.id] && tripDetailsData[viewingTrip.id].length > 0 ? (
                  <div>
                    {/* Группируем по заказам с учётом поиска и фильтра толщины */}
                    {(() => {
                      const searchLower = receivingDetailsSearch.toLowerCase().trim();
                      const groupedByOrder = {};

                      tripDetailsData[viewingTrip.id].forEach(detail => {
                        const orderNum = detail.order_number || detail.orderNumber;
                        const detailText = detail.detail_text || detail.detailText || '';

                        // Фильтрация по толщине
                        if (receivingThicknessFilter !== 'all') {
                          let t = detail.thickness || null;
                          if (!t && detail.glass_type) {
                            const match = detail.glass_type.match(/(\d+)\s*мм/i);
                            if (match) t = match[1] + 'мм';
                          }
                          const key = t || 'Без толщины';
                          if (key !== receivingThicknessFilter) return;
                        }

                        // Фильтрация по поиску
                        if (searchLower) {
                          const matchesOrder = orderNum?.toLowerCase().includes(searchLower);
                          const matchesDetail = detailText.toLowerCase().includes(searchLower);
                          const matchesColor = (detail.color || '').toLowerCase().includes(searchLower);
                          const matchesThickness = (detail.thickness || '').toLowerCase().includes(searchLower);

                          if (!matchesOrder && !matchesDetail && !matchesColor && !matchesThickness) {
                            return;
                          }
                        }

                        if (!groupedByOrder[orderNum]) {
                          groupedByOrder[orderNum] = [];
                        }
                        groupedByOrder[orderNum].push(detail);
                      });

                      const entries = Object.entries(groupedByOrder);

                      if (entries.length === 0 && searchLower) {
                        return (
                          <div className="text-center py-8 text-gray-500">
                            <p>Ничего не найдено по запросу "{receivingDetailsSearch}"</p>
                            <button
                              onClick={() => setReceivingDetailsSearch('')}
                              className="mt-2 text-blue-600 hover:underline text-sm"
                            >
                              Сбросить поиск
                            </button>
                          </div>
                        );
                      }

                      return entries.map(([orderNumber, details]) => (
                        <div key={orderNumber} className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
                          <div className="bg-gray-100 px-3 py-2 font-medium text-sm flex justify-between items-center">
                            <span>Заказ №{orderNumber}</span>
                            <span className="text-xs text-gray-500">{details.length} дет.</span>
                          </div>
                          <div className="p-3 space-y-2">
                            {details.map((detail, idx) => {
                              const detailText = detail.detail_text || detail.detailText;
                              const quantity = detail.quantity;
                              const uniqueDetailId = detail.id; // Используем уникальный ID из БД
                              const receivedQty = receivedDetails[uniqueDetailId] ?? 0; // По умолчанию 0 (снято)
                              const isReceivingStatus = viewingTrip.status === 'received_from_partner';

                              return (
                                <div key={idx} className={`flex justify-between items-start text-sm p-2 rounded ${
                                  isReceivingStatus && receivedQty === 0 ? 'bg-red-50 border border-red-200' : 'bg-gray-50'
                                }`}>
                                  <div className="flex-1">
                                    {isReceivingStatus && (
                                      <input
                                        type="checkbox"
                                        checked={receivedQty > 0}
                                        onChange={(e) => {
                                          const newQty = e.target.checked ? quantity : 0;
                                          setReceivedDetails(prev => ({
                                            ...prev,
                                            [uniqueDetailId]: newQty
                                          }));
                                          // Автоматическое сохранение
                                          debouncedSaveDetail(uniqueDetailId, newQty);
                                        }}
                                        className="mr-2 w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500 cursor-pointer align-middle"
                                      />
                                    )}
                                    <span className={`font-medium ${receivedQty === 0 ? 'text-gray-400 line-through' : ''}`}>
                                      {detailText}
                                    </span>
                                    {(detail.thickness || detail.color || detail.glass_type) && (
                                      <span className="ml-2 text-xs">
                                        {detail.glass_type && <span className="text-blue-600 font-medium">{detail.glass_type}</span>}
                                        {detail.glass_type && (detail.thickness || detail.color) && ' · '}
                                        {detail.thickness && <span className="text-gray-600">{detail.thickness}</span>}
                                        {detail.color && detail.thickness && ' '}
                                        {detail.color && <span className="text-gray-600 font-medium">{detail.color}</span>}
                                      </span>
                                    )}
                                  </div>
                                  <div className="ml-4 text-right flex items-center gap-2">
                                    {isReceivingStatus ? (
                                      <>
                                        <input
                                          type="number"
                                          min="0"
                                          max={quantity}
                                          value={receivedQty}
                                          onChange={(e) => {
                                            const newQty = Math.min(Math.max(0, parseInt(e.target.value) || 0), quantity);
                                            setReceivedDetails(prev => ({
                                              ...prev,
                                              [uniqueDetailId]: newQty
                                            }));
                                            // Автоматическое сохранение
                                            debouncedSaveDetail(uniqueDetailId, newQty);
                                          }}
                                          className="w-16 px-2 py-1 border border-gray-300 rounded text-xs text-center"
                                        />
                                        <span className="text-xs text-gray-500">из {quantity} шт</span>
                                        {/* Индикатор статуса сохранения */}
                                        <SaveStatusIndicator orderId={viewingTrip.id} detailId={uniqueDetailId} />
                                      </>
                                    ) : (
                                      <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                                        {quantity} шт
                                      </span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ));
                    })()}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    Нет деталей
                  </div>
                )}
              </div>
            </div>

            {/* Футер с кнопками действий */}
            <div className="border-t p-4 bg-gray-50">
              <div className="flex flex-wrap gap-2 items-center">
                {/* Кнопки для статуса "saved" - сохранен */}
                {viewingTrip.status === 'saved' && (
                  <button
                    onClick={async () => {
                      await handleAcceptByDriver(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                    }}
                    className="px-3 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                  >
                    🚚 Принять водителем
                  </button>
                )}

                {/* Кнопка для статуса "shipped" - принят водителем */}
                {viewingTrip.status === 'shipped' && (
                  <button
                    onClick={async () => {
                      await handleDeliverToPartner(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                    }}
                    className="px-3 py-2 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors"
                  >
                    🏭 Сдать партнеру
                  </button>
                )}

                {/* Кнопка для статуса "delivered_to_partner" - у партнера */}
                {viewingTrip.status === 'delivered_to_partner' && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromPartner(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                    }}
                    className="px-3 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors"
                  >
                    📦 Забрать у партнера
                  </button>
                )}

                {/* Кнопка для статуса "received_from_partner" - забран у партнера */}
                {viewingTrip.status === 'received_from_partner' && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromZakalka(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                    }}
                    className="px-3 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                  >
                    ✅ Принять с закалки
                  </button>
                )}

                {/* Кнопка Удалить - доступна для всех статусов */}
                <button
                  onClick={async () => {
                    await handleDeleteTrip(viewingTrip.id);
                    setShowViewTripModal(false);
                    setViewingTrip(null);
                  }}
                  className="px-3 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                >
                  🗑️ Удалить
                </button>

                {/* Кнопка закрыть всегда справа */}
                <button
                  onClick={() => {
                    setShowViewTripModal(false);
                    setViewingTrip(null);
                    setReceivingDetailsSearch('');
                  }}
                  className="ml-auto px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
                >
                  Закрыть
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      )}

      {/* Модальное окно редактирования деталей рейса */}
      {showEditModal && editingTrip && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] overflow-y-auto">
            <div className="min-h-screen flex items-start justify-center p-4 pt-8">
              <div className="bg-white rounded-lg max-w-4xl w-full max-h-[calc(100vh-4rem)] overflow-hidden flex flex-col shadow-2xl">
              {/* Заголовок */}
              <div className="flex items-center justify-between p-4 border-b">
                <div className="flex items-center gap-3">
                  <h2 className="text-lg font-semibold">
                    {editingTrip.id ? `Редактирование рейса #${editingTrip.tripNumber}` : 'Создание нового рейса'}
                  </h2>
                  {/* Индикатор автосохранения */}
                  {editingTrip.id && (() => {
                    const status = detailSavingStatus['trip_autosave'] || 'idle';
                    if (status === 'saving') {
                      return (
                        <span className="flex items-center text-xs text-gray-600">
                          <svg className="animate-spin h-3 w-3 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Сохранение...
                        </span>
                      );
                    }
                    if (status === 'saved') {
                      return (
                        <span className="flex items-center text-xs text-green-600">
                          <svg className="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                          Сохранено
                        </span>
                      );
                    }
                    if (status === 'error') {
                      return (
                        <span className="flex items-center text-xs text-red-600">
                          <svg className="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                          </svg>
                          Ошибка
                        </span>
                      );
                    }
                    return null;
                  })()}
                </div>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingTrip(null);
                    setLoadingTripDetailsInModal(false);
                    setLoadingAvailableDetailsInModal(false);
                    setTripDetailsThicknessFilter('all');
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>

              {/* Вкладки */}
<div className="border-b bg-gray-50">
  <div className="flex">
    <button
      onClick={() => setEditModalTab('details')}
      className={`flex-1 px-2 py-1 text-xs font-medium transition-colors ${
        editModalTab === 'details'
          ? 'text-blue-600 border-b border-blue-600 bg-white'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      📦 Детали ({tripDetails.filter(d => d.isSelected).length})
    </button>

    <button
      onClick={() => setEditModalTab('info')}
      className={`flex-1 px-2 py-1 text-xs font-medium transition-colors ${
        editModalTab === 'info'
          ? 'text-blue-600 border-b border-blue-600 bg-white'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      ⚙️ Инфо
    </button>

    <button
      onClick={() => setEditModalTab('preview')}
      className={`flex-1 px-2 py-1 text-xs font-medium transition-colors ${
        editModalTab === 'preview'
          ? 'text-blue-600 border-b border-blue-600 bg-white'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      👁️ Превью
    </button>
  </div>
</div>


              {/* Содержимое вкладок */}
              <div className="flex-1 overflow-y-auto p-2">

                {/* ВКЛАДКА 1: Детали */}
                {editModalTab === 'details' && (
                  <div>
                    {/* Поиск */}
                    <div className="mb-2">
                      <input
                        type="text"
                        value={tripDetailsSearch}
                        onChange={(e) => setTripDetailsSearch(e.target.value)}
                        placeholder="Поиск..."
                        className="w-full px-2 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                      />
                    </div>

                    {/* Фильтр по толщине стекла */}
                    {availableThicknesses.length > 0 && (
                      <div className="mb-2 flex flex-wrap gap-1">
                        <button
                          onClick={() => setTripDetailsThicknessFilter('all')}
                          className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
                            tripDetailsThicknessFilter === 'all'
                              ? 'bg-blue-500 text-white'
                              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                          }`}
                        >
                          Все ({tripDetails.length})
                        </button>
                        {availableThicknesses.map(thickness => {
                          const count = tripDetails.filter(d => {
                            let t = null;
                            if (d.thickness) t = d.thickness;
                            else if (d.glassType) {
                              const match = d.glassType.match(/(\d+)\s*мм/i);
                              if (match) t = match[1] + 'мм';
                            }
                            return t === thickness;
                          }).length;
                          return (
                            <button
                              key={thickness}
                              onClick={() => setTripDetailsThicknessFilter(thickness)}
                              className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
                                tripDetailsThicknessFilter === thickness
                                  ? 'bg-blue-500 text-white'
                                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                              }`}
                            >
                              {thickness} ({count})
                            </button>
                          );
                        })}
                      </div>
                    )}

                    {/* Список деталей */}
                    <div className="border border-blue-200 rounded bg-blue-50/50">
                      <div className="p-1.5 max-h-[400px] overflow-y-auto">
                        {loadingTripDetailsInModal ? (
                          <div className="flex flex-col items-center justify-center py-6">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mb-2"></div>
                            <p className="text-gray-500 text-xs">Загрузка...</p>
                          </div>
                        ) : Object.entries(groupedTripDetailsForEditModal).length > 0 ? (
                          <div className="space-y-1.5">
                            {Object.entries(groupedTripDetailsForEditModal).map(([orderId, details]) => (
                              <div key={orderId} className="border border-gray-200 rounded p-1.5 bg-white">
                                <h4 className="text-[10px] font-semibold text-gray-700 mb-1">
                                  №{details[0].orderNumber}
                                </h4>
                                <div className="space-y-0.5">
                                  {details.map((detail) => (
                                    <div
                                      key={detail.originalIndex}
                                      className={`flex items-center justify-between p-1 rounded text-[10px] ${
                                        detail.isSelected
                                          ? 'bg-blue-50 border border-blue-200'
                                          : 'bg-gray-50 border border-gray-100'
                                      }`}
                                    >
                                      <div className="flex items-center gap-1 flex-1 min-w-0">
                                        <input
                                          type="checkbox"
                                          checked={detail.isSelected}
                                          onChange={() => handleTripDetailToggle(detail.originalIndex)}
                                          className="w-3 h-3 text-blue-600 rounded cursor-pointer flex-shrink-0"
                                        />
                                        <span className="text-gray-800 truncate text-[10px]">{detail.detailText}</span>
                                        {detail.glassType && (
                                          <span className="px-1 py-0.5 bg-purple-100 text-purple-700 rounded text-[9px] flex-shrink-0">
                                            {detail.glassType}
                                          </span>
                                        )}
                                      </div>
                                      <div className="flex items-center gap-1 ml-1 flex-shrink-0">
                                        <button
                                          onClick={() => handleTripDetailQuantityChange(detail.originalIndex, detail.quantity - 1)}
                                          disabled={detail.quantity <= 1}
                                          className="w-5 h-5 rounded bg-red-100 hover:bg-red-200 text-red-600 text-[10px] font-bold disabled:opacity-50"
                                        >−</button>
                                        <span className="w-5 text-center text-[10px] font-medium">{detail.quantity}</span>
                                        <button
                                          onClick={() => handleTripDetailQuantityChange(detail.originalIndex, detail.quantity + 1)}
                                          disabled={detail.quantity >= detail.maxQuantity}
                                          className="w-5 h-5 rounded bg-green-100 hover:bg-green-200 text-green-600 text-[10px] font-bold disabled:opacity-50"
                                        >+</button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center py-4 text-gray-500 text-xs">
                            <p>{tripDetailsSearch ? 'Не найдено' : 'Нет деталей'}</p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Доступные детали (только при редактировании) */}
                    {editingTrip.id && (
                      <div className="mt-1.5">
                        <h3 className="text-xs font-semibold text-gray-700 mb-1">Доступные детали для добавления:</h3>
                        <div className="mb-1.5 flex gap-1.5">
                          <input
                            type="text"
                            value={availableDetailsSearch}
                            onChange={(e) => setAvailableDetailsSearch(e.target.value)}
                            placeholder="Поиск..."
                            className="flex-1 px-2 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                          />
                          <button
                            onClick={handleAddToTrip}
                            disabled={availableDetails.filter(d => d.isSelected && d.quantity > 0).length === 0}
                            className="px-2 py-1 bg-blue-500 text-white rounded text-xs hover:bg-blue-600 disabled:opacity-50"
                          >
                            ➕ Добавить
                          </button>
                        </div>
                        <div className="border border-green-300 rounded bg-green-50 p-1.5 max-h-52 overflow-y-auto">
                          {loadingAvailableDetailsInModal ? (
                            <div className="text-center py-2">
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-600 mx-auto"></div>
                            </div>
                          ) : Object.entries(groupedAvailableDetailsForEditModal).length > 0 ? (
                            <div className="space-y-1">
                              {Object.entries(groupedAvailableDetailsForEditModal).map(([orderId, details]) => (
                                <div key={orderId} className="border border-gray-200 rounded p-1.5 bg-white">
                                  <h4 className="text-[10px] font-semibold mb-0.5">Заказ №{details[0].orderNumber}</h4>
                                  {details.map((detail) => (
                                    <div key={detail.originalIndex} className="flex items-center gap-1 py-0.5 text-[10px]">
                                      <input
                                        type="checkbox"
                                        checked={detail.isSelected}
                                        onChange={() => handleAvailableDetailToggle(detail.originalIndex)}
                                        className="w-2.5 h-2.5"
                                      />
                                      <span className="flex-1">{detail.detailText}</span>
                                      {detail.glassType && (
                                        <span className="px-1 py-0.5 bg-purple-100 text-purple-700 rounded text-[9px]">
                                          {detail.glassType}
                                        </span>
                                      )}
                                      <div className="flex items-center gap-0.5">
                                        <button
                                          onClick={() => handleAvailableDetailQuantityChange(detail.originalIndex, detail.quantity - 1)}
                                          disabled={detail.quantity <= 0}
                                          className="w-4 h-4 rounded bg-red-100 text-red-600 text-[10px] disabled:opacity-50"
                                        >−</button>
                                        <span className="w-5 text-center">{detail.quantity}</span>
                                        <button
                                          onClick={() => handleAvailableDetailQuantityChange(detail.originalIndex, detail.quantity + 1)}
                                          disabled={detail.quantity >= detail.maxQuantity}
                                          className="w-4 h-4 rounded bg-green-100 text-green-600 text-[10px] disabled:opacity-50"
                                        >+</button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-center text-gray-500 text-xs py-2">Нет доступных деталей</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* ВКЛАДКА 2: Информация */}
                {editModalTab === 'info' && (
                  <div className="space-y-3">
                    {/* Тип рейса */}
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Тип рейса</label>
                      <div className={`inline-block px-2 py-1 rounded text-xs font-medium ${
                        editingTrip.type === 'shipping'
                          ? 'bg-purple-100 text-purple-800'
                          : 'bg-orange-100 text-orange-800'
                      }`}>
                        {editingTrip.type === 'shipping' ? '📤 Отгрузка' : '📥 Прием'}
                      </div>
                    </div>

                    {/* Партнер закалки */}
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Партнер закалки</label>
                      <select
                        value={tripPartner}
                        onChange={(e) => setTripPartner(e.target.value)}
                        className="w-full px-2 py-1.5 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                      >
                        <option value="Казстековид">Казстековид</option>
                        <option value="Премиумгласс">Премиумгласс</option>
                        <option value="Руслан">Руслан</option>
                      </select>
                    </div>

                    {/* Примечания */}
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Примечания</label>
                      <textarea
                        value={editingTrip?.notes || ''}
                        onChange={(e) => setEditingTrip({...editingTrip, notes: e.target.value})}
                        placeholder="Примечания (необязательно)"
                        className="w-full px-2 py-1.5 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                        rows="3"
                      />
                    </div>
                  </div>
                )}

                {/* ВКЛАДКА 3: Превью */}
                {editModalTab === 'preview' && (
                  <div>
                    {(() => {
                      const selectedDetails = tripDetails.filter(d => d.isSelected);
                      const totalQuantity = selectedDetails.reduce((sum, d) => sum + (d.quantity || 1), 0);
                      const uniqueOrders = new Set(selectedDetails.map(d => d.orderId)).size;

                      // Группировка по толщине стекла
                      const thicknessStats = {};
                      selectedDetails.forEach(detail => {
                        let thickness = 'Неизвестно';
                        if (detail.glassType) {
                          const match = detail.glassType.match(/(\d+)\s*мм/i);
                          if (match) thickness = match[1] + 'мм';
                        }
                        if (!thicknessStats[thickness]) {
                          thicknessStats[thickness] = { count: 0, details: [] };
                        }
                        thicknessStats[thickness].count += detail.quantity || 1;
                        thicknessStats[thickness].details.push(detail);
                      });

                      // Группировка по типу стекла
                      const glassTypeStats = {};
                      selectedDetails.forEach(detail => {
                        const type = detail.glassType || 'Неизвестно';
                        if (!glassTypeStats[type]) {
                          glassTypeStats[type] = 0;
                        }
                        glassTypeStats[type] += detail.quantity || 1;
                      });

                      return (
                        <div className="space-y-3">
                          {/* Общая статистика */}
                          <div className="bg-blue-50 border border-blue-200 rounded p-2">
                            <h3 className="text-xs font-semibold text-blue-800 mb-2">Сводка</h3>
                            <div className="grid grid-cols-3 gap-2 text-center">
                              <div className="bg-white rounded p-1.5">
                                <p className="text-lg font-bold text-blue-600">{uniqueOrders}</p>
                                <p className="text-[10px] text-gray-500">Заказов</p>
                              </div>
                              <div className="bg-white rounded p-1.5">
                                <p className="text-lg font-bold text-green-600">{selectedDetails.length}</p>
                                <p className="text-[10px] text-gray-500">Позиций</p>
                              </div>
                              <div className="bg-white rounded p-1.5">
                                <p className="text-lg font-bold text-purple-600">{totalQuantity}</p>
                                <p className="text-[10px] text-gray-500">Деталей</p>
                              </div>
                            </div>
                          </div>

                          {/* По толщине стекла */}
                          <div className="bg-gray-50 border border-gray-200 rounded p-2">
                            <h3 className="text-xs font-semibold text-gray-700 mb-2">По толщине</h3>
                            {Object.keys(thicknessStats).length > 0 ? (
                              <div className="flex flex-wrap gap-1.5">
                                {Object.entries(thicknessStats)
                                  .filter(([t]) => t !== 'Неизвестно')
                                  .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
                                  .map(([thickness, data]) => (
                                    <div key={thickness} className="bg-white border border-blue-200 rounded px-2 py-1 text-center">
                                      <p className="text-sm font-bold text-blue-600">{data.count}</p>
                                      <p className="text-[10px] text-gray-500">{thickness}</p>
                                    </div>
                                  ))}
                                {thicknessStats['Неизвестно'] && (
                                  <div className="bg-white border border-gray-300 rounded px-2 py-1 text-center">
                                    <p className="text-sm font-bold text-gray-500">{thicknessStats['Неизвестно'].count}</p>
                                    <p className="text-[10px] text-gray-400">?</p>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-gray-500 text-xs">Нет деталей</p>
                            )}
                          </div>

                          {/* По типу стекла */}
                          <div className="bg-gray-50 border border-gray-200 rounded p-2">
                            <h3 className="text-xs font-semibold text-gray-700 mb-2">По типу стекла</h3>
                            {Object.keys(glassTypeStats).length > 0 ? (
                              <div className="space-y-1">
                                {Object.entries(glassTypeStats)
                                  .filter(([t]) => t !== 'Неизвестно')
                                  .sort((a, b) => b[1] - a[1])
                                  .map(([type, count]) => (
                                    <div key={type} className="flex items-center justify-between bg-white border border-purple-100 rounded px-2 py-1">
                                      <span className="text-xs text-purple-700">{type}</span>
                                      <span className="text-xs font-bold text-purple-600">{count} шт</span>
                                    </div>
                                  ))}
                              </div>
                            ) : (
                              <p className="text-gray-500 text-xs">Нет деталей</p>
                            )}
                          </div>

                          {/* Информация о рейсе */}
                          <div className="bg-yellow-50 border border-yellow-200 rounded p-2">
                            <div className="flex items-center gap-2 text-xs">
                              <span className="text-yellow-700">Партнер:</span>
                              <span className="font-medium text-yellow-800">{tripPartner}</span>
                              {editingTrip?.notes && (
                                <>
                                  <span className="text-yellow-600">|</span>
                                  <span className="text-yellow-700 truncate">{editingTrip.notes}</span>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Кнопки действий */}
                          <div className="flex flex-col gap-2 mt-3 pt-3 border-t">
                            <button
                              onClick={() => handleSaveTrip()}
                              disabled={creatingTrip || selectedDetails.length === 0}
                              className="w-full px-3 py-2 text-xs bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors disabled:opacity-50 font-medium"
                            >
                              {creatingTrip ? (editingTrip.id ? '⏳ Сохранение...' : '⏳ Создание...') : (editingTrip.id ? '💾 Сохранить' : '✅ Создать рейс')}
                            </button>
                            <div className="flex gap-2">
                              <button
                                onClick={handleGenerateTripPartnerPDF}
                                disabled={generatingPartnerPDF || selectedDetails.length === 0 || loadingTripDetailsInModal}
                                className="flex-1 px-2 py-1.5 text-xs bg-purple-500 hover:bg-purple-600 text-white rounded transition-colors disabled:opacity-50"
                              >
                                {generatingPartnerPDF ? '⏳...' : '📄 Отчет'}
                              </button>
                              <button
                                onClick={() => {
                                  setShowEditModal(false);
                                  setEditingTrip(null);
                                  setLoadingTripDetailsInModal(false);
                                  setLoadingAvailableDetailsInModal(false);
                                  setTripDetailsThicknessFilter('all');
                                }}
                                className="flex-1 px-2 py-1.5 text-xs bg-gray-200 hover:bg-gray-300 rounded transition-colors"
                                disabled={creatingTrip}
                              >
                                Отмена
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default ZakalkaOrdersPageB24;